<template>
  <div class="bookRoom">
    <Sidebar_user :setorders="orders" />
    <div class="home-section">
      <b-container>
        <!-- ============== Calendar ===================== -->

        <div class="space"></div>
        <div class="calendar-list">
          <div class="card card-order-list card-margin calendar-border">
            <div class="card-body">
              <div class="container">
                <div class="card-content-more">
                  <h1 class="btn-floating">
                    <!-- {{ choosedDay2 }} -->
                    {{ choosedDay2.dateFormat | moment }}

                    <!-- {{ date| moment }} -->
                  </h1>
                </div>
                <!-- :minDate="dateTime" rgb(255,95,45)-->
                <vue-horizontal-calendar
                  choosedDate:dateTime
                  v-on:change="dateChange2"
                  lang="en"
                  choosedItemColor="
              #fc4170"
                  todayItemColor="rgb(150, 0, 0, .1)"
                  :minDate="dateTime"
                >
                  <img
                    slot="leftIcon"
                    src="../../assets/icons/right.png"
                    style="width: 20px; margin-top: -2px"
                  />
                  <img
                    slot="rightIcon"
                    src="../../assets/icons/left.png"
                    style="width: 20px; margin-top: -2px"
                  />
                </vue-horizontal-calendar>
              </div>
            </div>
          </div>
        </div>
        <!-- =============== END ========================== -->
        <!-- ====================================== Room Booked =============================================-->
        <br />

        <div class="time-column">
          <!-- time-column ""-->

          <div class="card-columns">
            <!-- v-for="(std, inx) in history"
              :key="inx" -->
            <!-- ====================================== รายละเอียดการจองห้อง ===========================================-->
            <!-- v-for="(std, inx) in history"
            :key="inx" -->
            <div
              v-for="(std, inx) in history"
              :key="inx"
              class="card card-order-list card-margin border-0 card-service"
            >
              <!-- ====================================  แจ้งแตือนยกเลิก จองห้องเรียบร้อย ================================= -->
              <!-- <div class="card-body" :style="{padding: 2 + 'px',marginTop:5+'px',bottom:-5 +'px'}">
              <h6 class="card-title overtime-detail">
                <i class="fa-solid fa-face-sad-cry" :style="{fontSize:30 +'px',padding:12 +'px',color:'#FF6600'}"></i>
                ห้อง MEETING 3A ของคุณ <b>ยกเลิกแล้ว</b>
              </h6>
            </div> -->

              <!-- ====================================== END ======================================================= -->
              <div class="card-body">
                <div class="card-title">
                  <h5><b>รายละเอียดการจอง</b></h5>
                </div>
                <hr class="ml-2" />

                <!-- v-if="
                    std.room_id === 1 ||
                    std.room_id === 2 ||
                    std.room_id === 3 ||
                    std.room_id === 4 ||
                    std.room_id === 5 ||
                    std.room_id === 6 ||
                    std.room_id === 7
                  "  -->
                <span>
                  <p class="text-left" style="font-size: 14px">
                    <i class="fa-solid fa-location-dot"></i>
                    {{ std.room_desc }}
                  </p>
                  <!-- {{ std.room_name}} -->
                  <p class="text-left" style="font-size: 14px">
                    ห้องที่จอง : {{ std.room_name }}
                  </p>

                  <!-- {{ std.whois_std_name }} -->
                  <p class="text-left" style="font-size: 14px">
                    ชื่อผู้จอง : {{ std.whois_std_name }}
                  </p>
                  <!-- {{ std. }} -->
                  <p class="text-left" style="font-size: 14px">
                    รหัสผู้จอง: {{ std.whois_std_code }}
                  </p>
                  <!--  -->
                  <p
                    class="text-left"
                    style="font-size: 14px"
                    v-if="std.trans_status === 'booked'"
                  >
                    สถานะการจอง :
                    <b
                      style="
                        padding: 7px;
                        background-color: gray;
                        border-radius: 30px;
                        color: white;
                        font-size: 12px;
                      "
                      >รอยืนยัน</b
                    >
                  </p>
                  <!--  -->

                  <p
                    class="text-left"
                    style="font-size: 14px"
                    v-if="
                      std.trans_status === 'inlocker' &&
                      std.locker_number !== ''
                    "
                  >
                    สถานะการจอง :

                    <b
                      style="
                        padding: 6px;
                        background-color: orangered;
                        border-radius: 30px;
                        color: white;
                        font-size: 10px;
                      "
                      >รับกุญแจที่เคาน์เตอร์บริการยืมคืน</b
                    >
                  </p>
                  <!--  -->
                  <p
                    class="text-left"
                    style="font-size: 14px"
                    v-if="std.trans_status === 'borrowed'"
                  >
                    สถานะการจอง :
                    <b
                      style="
                        padding: 7px;
                        background-color: green;
                        border-radius: 30px;
                        color: white;
                        font-size: 12px;
                      "
                      >กำลังใช้งาน</b
                    >
                  </p>
                  <!--  -->

                  <p
                    class="text-left"
                    style="font-size: 14px"
                    v-if="std.trans_status === 'approved'"
                  >
                    สถานะการจอง :

                    <b
                      style="
                        padding: 7px;
                        background-color: green;
                        border-radius: 30px;
                        color: white;
                        font-size: 12px;
                      "
                      >กำลังใช้งาน</b
                    >
                  </p>

                  <hr class="ml-6" />
                  <p
                    v-if="
                      std.trans_status === 'inlocker' &&
                      std.locker_number !== ''
                    "
                    style="font-size: 10px"
                    class="text-left"
                  >
                    หมายเหตุ: กรุณารับกุญแจภายใน 1 ชั่วโมง หากเกินเวลาที่กำหนด
                    เจ้าหน้าที่จะทำการยกเลิกการจองห้อง
                  </p>
                </span>
              </div>
            </div>
            <!-- ======================================= Modal detail meeting room==================================== -->
            <b-modal
              id="modal-cancel-room"
              size="sm"
              headerClass="p-0 border-bottom-0"
              footerClass="p-0 border-top-0"
              centered
              hide-header
              class="modal-cancel-roomm"
            >
              <h6 class="my-4">กรุณากด <b>ยืนยัน</b> เพื่อยกเลิกการจองห้อง</h6>
              <template #modal-title>
                <h5 class="m-1"><b>ยกเลิกการจอง</b></h5>
              </template>

              <template #modal-footer="{ ok, cancel }">
                <b-form @submit.prevent="cancelRoom('ยกเลิกการจองห้อง')">
                  <b-button
                    size=""
                    class="b-between block"
                    variant="success"
                    data-dismiss="modal"
                    type="submit"
                    pill
                    @click="ok()"
                  >
                    ยืนยัน
                  </b-button>

                  <b-button
                    size=""
                    class="b-between"
                    variant="secondary"
                    pill
                    @click="cancel()"
                  >
                    เอาไว้ก่อน
                  </b-button>
                </b-form>
              </template>
            </b-modal>

            <!-- ======================================= END ========================================================= -->

            <!-- ========================================= END ========================================================= -->
          </div>
        </div>

        <!-- ====================================== END ===================================================== -->

        <!-- ==================== Tabs Menu =====================  -->
        <div class="space"></div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="segmented-control">
              <!-- active meeting-->
              <input
                type="radio"
                name="radio2"
                v-model="radio_btn"
                @change="onChange"
                value=""
                id="tab-1"
                checked
              />
              <label for="tab-1" class="segmented-control__1"
                ><p>ห้องกลุ่มย่อย</p></label
              >

              <!-- studio -->
              <input
                type="radio"
                name="radio2"
                id="tab-2"
                value="studio"
                v-model="radio_btn"
                @change="onChange"
              />
              <label for="tab-2" class="segmented-control__2"
                ><p>ห้องสตูดิโอ</p></label
              >
              <!-- radio record -->
              <input
                type="radio"
                name="radio2"
                id="tab-3"
                value="racord"
                v-model="radio_btn"
                @change="onChange"
              />
              <label for="tab-3" class="segmented-control__3"
                ><p>ห้องบันทึกเสียง</p></label
              >

              <div class="segmented-control__color"></div>
            </div>
          </div>
        </div>
        <!-- ======================== END ========================= -->

        <!-- ======================== Tabs Detail ================ -->
        <div class="space"></div>
        <!-- *********************** Meeting Room ******************** -->
        <div class="detail" v-if="radio_btn === ''">
          <div class="button-group">
            <b-button
              v-for="(building, index) in buildings"
              :key="index"
              :variant="
                activeIndex === index ? 'secondary' : 'outline-secondary'
              "
              class="custom-button"
              @click="selectBuilding(index)"
            >
              {{ building.name }}
            </b-button>
          </div>
          <br />
          <div v-if="activeIndex !== null" class="card-columns">
            <!-- <template v-if="buildings[activeIndex].detail == 0 && ['Sa', 'Su'].includes(choosedDay2.day)">
              <div class="card-columns">
                <div class="card-input">
                  <div
                    class="card card-order-list card-margin border-0 card-service"
                  >
                    <div class="card-body">
                      <i
                        class="fa-solid fa-circle-exclamation fa-1x"
                        style="color: #bc060f"
                      ></i>
                      สามารถจองห้อง Training Room 2 3 และ 4 ได้ในวันทำการ จันทร์ - ศุกร์
                      ขออภัยในความไม่สะดวก
                    </div>
                  </div>
                </div>
              </div>
            </template> -->

            <!-- อาคาร 13 -->
            <!-- <span> -->
            <div class="card-room" v-if="buildings[activeIndex].detail == 0">
              <span v-for="(aitem, index) in itembd" :key="index">
                <!-- Teacher อาคาร 13 -->

                <span v-if="!isShowstaff">
                  <!-- ส อ -->
                  <template v-if="['Sa', 'Su'].includes(choosedDay2.day)">
                    <div class="card-input">
                      <div
                        class="top-50 start-50 translate-middle"
                        v-if="[24].includes(aitem.room_id)"
                      >
                        <div
                          class="animate__animated animate bounce card card-detail-tebs"
                          style="width: 18rem"
                        >
                          <div class="container mt-3 container-img">
                            <img
                              v-if="aitem.room_id === 24"
                              src="../../assets/meetingrooms/training.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                          </div>

                          <div class="card-body">
                            <h5 class="card-title ms-1">
                              <b>{{ aitem.room_name }}</b>
                            </h5>
                            <p class="card-text mb-3 ms-1 detail-size-text">
                              <i class="fa-solid fa-location-dot"></i>
                              {{ aitem.room_desc }}
                            </p>
                            <!-- ====================== ถูกจองแล้ว variant="outline-secondary"  disabled=============================-->
                            <span
                              v-if="
                                aitem.status === 1 ||
                                (aitem.status === 0 &&
                                  aitem.freetimes.length === 0)
                              "
                            >
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                              >
                                08:30 - 12:00
                              </b-button>
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                              >
                                13:00 - 16:30
                              </b-button>
                            </span>

                            <!-- ====================== END =========================================== -->
                            <!-- ====================== ห้องว่าง variant="outline-pink" =============================-->
                            <span v-for="(prod, j) of aitem.freetimes" :key="j">
                              <!-- Start v-if=== !user -->

                              <b-button
                                v-if="
                                  aitem.freetimes.length === 1 &&
                                  aitem.status === 0 &&
                                  prod.time_begin === '13:00'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="btn mb-1 mt-1 time-btn"
                              >
                                08:30 - 12:00
                              </b-button>

                              <b-button
                                pill
                                v-if="
                                  prod.time_begin !== '08:30' ||
                                  prod.time_end !== '16:30'
                                "
                                variant="outline-pink"
                                class="btn mb-1 mt-1 time-btn"
                                v-b-modal="
                                  'modal-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                @click="getUsefor(aitem.room_id)"
                              >
                                {{ prod.time_begin }} - {{ prod.time_end }}
                              </b-button>
                              <span
                                v-for="(timechkuser, iu) in historyall"
                                :key="iu"
                              >
                                <b-button
                                  pill
                                  v-if="
                                    timechkuser.room_id === aitem.room_id &&
                                    timechkuser.time_begin === '13:00' &&
                                    timechkuser.time_begin !==
                                      prod.time_begin &&
                                    aitem.freetimes.length === 1
                                  "
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  13:00 - 16:30
                                </b-button>
                              </span>

                              <!-- END v-if === !user -->
                              <!-- Start v-if === user -->
                              <!-- END v-if == user -->

                              <!-- ============================= Modal ======================== -->
                              <!-- *************************** Teacher Modal************************* -->
                              <!-- v-if="chkbookingroom" -->
                              <b-modal
                                :hide-footer="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="chkbookingroom"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ aitem.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>
                                <div
                                  class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          aitem.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingAnother' +
                                            aitem.room_id +
                                            prod.time_id
                                        )
                                      "
                                    >
                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3 input-style"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>

                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        id=""
                                        v-model="input_another"
                                        v-if="[7, 13, 16].includes(selected)"
                                      />

                                      <b-button
                                        :disabled="!isCompleteTeach"
                                        type="submit"
                                        class="btn btn-pink deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </b-button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <!-- v-if="!chkbookingroom" -->
                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i
                                    >{{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                              <!-- *************************** END ****************************** -->
                              <!-- ============================= ENdD ======================== -->
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- อาคาร 13  -->
                  <span v-else>
                    <div class="card-input">
                      <!-- , 24, 26 ปิดห้อง traingroom 3 ชั่วคราว เนื่องจากเครื่องปรับอากาศเสีย  -->
                      <div
                        class="top-50 start-50 translate-middle"
                        v-if="[24,25, 26,27].includes(aitem.room_id)"
                      >
                        <div
                          class="animate__animated animate bounce card card-detail-tebs"
                          style="width: 18rem"
                        >
                          <div class="container mt-3 container-img">
                            <img
                              v-if="aitem.room_id === 24"
                              src="../../assets/meetingrooms/training.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                            <img
                              v-if="aitem.room_id === 25"
                              src="../../assets/meetingrooms/training2.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                            <img
                              v-if="aitem.room_id === 26"
                              src="../../assets/meetingrooms/training3.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                            <img
                              v-if="aitem.room_id === 27"
                              src="../../assets/meetingrooms/training4.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                          </div>

                          <div class="card-body">
                            <h5 class="card-title ms-1">
                              <b>{{ aitem.room_name }}</b>
                            </h5>
                            <p class="card-text mb-3 ms-1 detail-size-text">
                              <i class="fa-solid fa-location-dot"></i>
                              {{ aitem.room_desc }}
                            </p>
                            <!-- ====================== ถูกจองแล้ว variant="outline-secondary"  disabled=============================-->
                            <span
                              v-if="
                                aitem.status === 1 ||
                                (aitem.status === 0 &&
                                  aitem.freetimes.length === 0)
                              "
                            >
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                              >
                                08:30 - 12:00
                              </b-button>
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                              >
                                13:00 - 16:30
                              </b-button>
                            </span>

                            <!-- ====================== END =========================================== -->
                            <!-- ====================== ห้องว่าง variant="outline-pink" =============================-->
                            <span v-for="(prod, j) of aitem.freetimes" :key="j">
                              <!-- Start v-if=== !user -->

                              <b-button
                                v-if="
                                  aitem.freetimes.length === 1 &&
                                  aitem.status === 0 &&
                                  prod.time_begin === '13:00'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="btn mb-1 mt-1 time-btn"
                              >
                                08:30 - 12:00
                              </b-button>

                              <b-button
                                pill
                                v-if="
                                  prod.time_begin !== '08:30' ||
                                  prod.time_end !== '16:30'
                                "
                                variant="outline-pink"
                                class="btn mb-1 mt-1 time-btn"
                                v-b-modal="
                                  'modal-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                @click="getUsefor(aitem.room_id)"
                              >
                                {{ prod.time_begin }} - {{ prod.time_end }}
                              </b-button>
                              <span
                                v-for="(timechkuser, iu) in historyall"
                                :key="iu"
                              >
                                <b-button
                                  pill
                                  v-if="
                                    timechkuser.room_id === aitem.room_id &&
                                    timechkuser.time_begin === '13:00' &&
                                    timechkuser.time_begin !==
                                      prod.time_begin &&
                                    aitem.freetimes.length === 1
                                  "
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  13:00 - 16:30
                                </b-button>
                              </span>

                              <!-- END v-if === !user -->
                              <!-- Start v-if === user -->
                              <!-- END v-if == user -->

                              <!-- ============================= Modal ======================== -->
                              <!-- *************************** Teacher Modal************************* -->
                              <!-- v-if="chkbookingroom" -->
                              <b-modal
                                :hide-footer="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="chkbookingroom"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ aitem.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>
                                <div
                                  class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          aitem.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingAnother' +
                                            aitem.room_id +
                                            prod.time_id
                                        )
                                      "
                                    >
                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3 input-style"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>

                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        id=""
                                        v-model="input_another"
                                        v-if="[7, 13, 16].includes(selected)"
                                      />

                                      <b-button
                                        :disabled="!isCompleteTeach"
                                        type="submit"
                                        class="btn btn-pink deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </b-button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <!-- v-if="!chkbookingroom" -->
                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i
                                    >{{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                              <!-- *************************** END ****************************** -->
                              <!-- ============================= ENdD ======================== -->
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                </span>

                <!-- Student อาคาร 13 STD-->
                <span v-if="isShowstaff">
                  <!-- ส อ -->
                  <template v-if="['Sa', 'Su'].includes(choosedDay2.day)">
                    <div class="card-input">
                      <div
                        class="top-50 start-50 translate-middle"
                        v-if="[24].includes(aitem.room_id)"
                      >
                        <div
                          class="animate__animated animate bounce card card-detail-tebs"
                          style="width: 18rem"
                        >
                          <div class="container mt-3 container-img">
                            <img
                              v-if="aitem.room_id === 24"
                              src="../../assets/meetingrooms/training.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                          </div>

                          <div class="card-body">
                            <h5 class="card-title ms-1">
                              <b>{{ aitem.room_name }}</b>
                            </h5>
                            <p class="card-text mb-3 ms-1 detail-size-text">
                              <i class="fa-solid fa-location-dot"></i>
                              {{ aitem.room_desc }}
                            </p>
                            <!-- ====================== ถูกจองแล้ว variant="outline-secondary"  disabled=============================-->

                            <span
                              v-if="
                                aitem.status === 1 ||
                                (aitem.status === 0 &&
                                  aitem.freetimes.length === 0)
                              "
                            >
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                              >
                                08:30 - 12:00
                              </b-button>
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                              >
                                13:00 - 16:30
                              </b-button>
                            </span>

                            <!-- ====================== END =========================================== -->
                            <!-- ====================== ห้องว่าง variant="outline-pink" =============================-->
                            <span v-for="(prod, j) of aitem.freetimes" :key="j">
                              <span v-if="!user">
                                <b-button
                                  v-if="
                                    aitem.freetimes.length === 1 &&
                                    aitem.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  08:30 - 12:00
                                </b-button>

                                <b-button
                                  v-if="
                                    aitem.freetimes.length === 1 &&
                                    aitem.status === 0 &&
                                    prod.time_begin === '16:30'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  13:00 -16:30
                                </b-button>

                                <b-button
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    prod.time_end !== '16:30'
                                  "
                                  variant="outline-pink"
                                  class="btn mb-1 mt-1 time-btn"
                                  v-b-modal="
                                    'modal-meeting-std-main' +
                                    aitem.room_id +
                                    prod.time_id
                                  "
                                  @click="getUsefor(aitem.room_id)"
                                >
                                  {{ prod.time_begin }} - {{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuse, iue) in historyall"
                                  :key="iue"
                                >
                                  <b-button
                                    v-if="
                                      timechkuse.room_id === aitem.room_id &&
                                      timechkuse.time_begin === '13:00' &&
                                      timechkuse.time_begin !==
                                        prod.time_begin &&
                                      aitem.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="btn mb-1 mt-1 time-btn"
                                  >
                                    13:00 -16:30
                                  </b-button>
                                </span>
                              </span>
                              <!-- END v-if == !user -->

                              <!-- Start v-if === !user -->
                              <!-- END v-if === User -->
                              <span v-if="user">
                                <b-button
                                  v-if="
                                    aitem.freetimes.length === 1 &&
                                    aitem.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  08:30 - 12:00
                                </b-button>

                                <b-button
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    (prod.time_end !== '16:30' &&
                                      aitem.freetimes.length !== 0)
                                  "
                                  pill
                                  variant="outline-pink"
                                  class="btn mb-1 mt-1 time-btn"
                                  href="/login"
                                >
                                  {{ prod.time_begin }} - {{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuser, iu) in historyall"
                                  :key="iu"
                                >
                                  <b-button
                                    v-if="
                                      timechkuser.room_id === aitem.room_id &&
                                      timechkuser.time_begin === '13:00' &&
                                      timechkuser.time_begin !==
                                        prod.time_begin &&
                                      aitem.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="btn mb-1 mt-1 time-btn"
                                  >
                                    13:00 - 16:30
                                  </b-button>
                                </span>
                              </span>
                              <!-- ============================= Modal ======================== -->
                              <!-- *************************** std manin************************* -->
                              <!-- v-if="chkbookingroom" -->
                              <b-modal
                                :hide-footer="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meeting-std-main' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="chkbookingroom"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ aitem.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>
                                <div
                                  class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        booking(
                                          aitem.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meeting-std-main' +
                                            aitem.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        (auth.isLibraryStaff === 1 &&
                                          aitem.floor !== 6) ||
                                        auth.LibraryStaff !== 1
                                      "
                                    >
                                      <!-- v-if="
                                  (auth.isLibraryStaff === 1 &&
                                    ![6].includes(aitem.floor)) ||
                                  auth.isLibraryStaff !== 1 -->

                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3 input-style"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>

                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        id=""
                                        v-model="input_another"
                                        v-if="[7, 13, 16].includes(selected)"
                                      />
                                      <p style="color: red">
                                        **หมายเหตุ : กรอกรหัสนักศึกษา
                                        {{ aitem.min_person }} คนขึ้นไป
                                      </p>
                                      <span
                                        style="color: red"
                                        v-if="error != '' || error === null"
                                      >
                                        **{{ error }}
                                      </span>
                                      <b-row>
                                        <b-col
                                          cols="6"
                                          v-for="(stdr, index) in 6"
                                          :key="index"
                                        >
                                          <input
                                            class="form-control input-style"
                                            placeholder="กรอกรหัสนักศึกษา"
                                            maxlength="11"
                                            v-model="values[index]"
                                          />
                                        </b-col>
                                      </b-row>

                                      <b-button
                                        :disabled="!isComplete"
                                        type="submit"
                                        class="btn btn-pink deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </b-button>
                                    </form>

                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          aitem.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meeting-std-main1' +
                                            aitem.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        auth.isLibraryStaff === 1 &&
                                        aitem.floor === 6
                                      "
                                    >
                                      <!-- v-if="
                                      auth.isLibraryStaff === 1 &&
                                      aitem.floor === 6
                                    " -->
                                      <!-- Teacher -->
                                      <span>
                                        <b-button variant="outline-primary">
                                          สำหรับอาจารย์
                                        </b-button>
                                      </span>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>

                                      <b-row>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="เบอร์โทรศัพท์"
                                            maxlength="10"
                                            v-model="input_room_Teacher_phone"
                                          />
                                        </b-col>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="ชื่อ - นามสกุล"
                                            v-model="input_room_Teacher_name"
                                            type="text"
                                            autocomplete=""
                                          />
                                        </b-col>
                                        <!-- options fac-->
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedfac"
                                            :options="optionsfac"
                                            value-field="fac_code"
                                            class="mb-3 input-style"
                                            text-field="fac_name"
                                            disabled-field="notEnabled"
                                            @change="get_branch()"
                                          >
                                            <!-- Teacher -->
                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                              >
                                                เลือกคณะ
                                              </b-form-select-option>
                                            </template>
                                          </b-form-select>
                                        </b-col>
                                        <!-- option branch -->
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedbranch"
                                            :options="optionsbranch"
                                            class="mb-3 input-style"
                                            value-field="branch_code"
                                            text-field="branch_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->
                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                              >
                                                เลือกสาขา
                                              </b-form-select-option>
                                            </template>
                                          </b-form-select>
                                        </b-col>

                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="อีเมล"
                                            maxlength=""
                                            type="email"
                                            v-model="input_room_Teacher_email"
                                          />
                                        </b-col>

                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selected"
                                            :options="options"
                                            class="mb-3 input-style"
                                            value-field="usefor_id"
                                            text-field="usefor_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->
                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                              >
                                                เลือกวัตถุประสงค์การใช้งาน
                                              </b-form-select-option>
                                            </template>
                                          </b-form-select>
                                          <input
                                            type="text"
                                            class="form-control input-style"
                                            placeholder="กรอกวัตถุประสงค์"
                                            v-model="input_another"
                                            v-if="
                                              [7, 13, 16].includes(selected)
                                            "
                                          />
                                        </b-col>
                                      </b-row>
                                    </form>

                                    <button
                                      v-if="
                                        auth.isLibraryStaff === 1 &&
                                        [6].includes(aitem.floor)
                                      "
                                      :disabled="!isCompleteAnothor"
                                      type="submit"
                                      class="btn btn-pink deep-purple btn-block badge-pill"
                                      data-dismiss="modal"
                                      @click="showModal = false"
                                    >
                                      ยืนยัน
                                    </button>
                                  </div>
                                </div>
                              </b-modal>

                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meeting-std-main' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i
                                    >{{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>

                              <!-- *************************** END ****************************** -->
                              <!-- ============================= ENdD ======================== -->
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- จ-ศ -->
                  <span v-else>
                    <div class="card-input">
                       <!-- ,24,  26 ปิดห้อง traingroom 3 ชั่วคราว เนื่องจากเครื่องปรับอากาศเสีย -->
                      <div
                        class="top-50 start-50 translate-middle"
                        v-if="[24,25, 26, 27].includes(aitem.room_id)"
                      >
                        <div
                          class="animate__animated animate bounce card card-detail-tebs"
                          style="width: 18rem"
                        >
                          <div class="container mt-3 container-img">
                            <img
                              v-if="aitem.room_id === 24"
                              src="../../assets/meetingrooms/training.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                            <img
                              v-if="aitem.room_id === 25"
                              src="../../assets/meetingrooms/training2.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                            <img
                              v-if="aitem.room_id === 26"
                              src="../../assets/meetingrooms/training3.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                            <img
                              v-if="aitem.room_id === 27"
                              src="../../assets/meetingrooms/training4.jpeg"
                              class="card-img-top"
                              alt="..."
                            />
                          </div>

                          <div class="card-body">
                            <h5 class="card-title ms-1">
                              <b>{{ aitem.room_name }}</b>
                            </h5>
                            <p class="card-text mb-3 ms-1 detail-size-text">
                              <i class="fa-solid fa-location-dot"></i>
                              {{ aitem.room_desc }}
                            </p>
                            <!-- ====================== ถูกจองแล้ว variant="outline-secondary"  disabled=============================-->

                            <span
                              v-if="
                                aitem.status === 1 ||
                                (aitem.status === 0 &&
                                  aitem.freetimes.length === 0)
                              "
                            >
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                              >
                                08:30 - 12:00
                              </b-button>
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                              >
                                13:00 - 16:30
                              </b-button>
                            </span>

                            <!-- ====================== END =========================================== -->
                            <!-- ====================== ห้องว่าง variant="outline-pink" =============================-->
                            <span v-for="(prod, j) of aitem.freetimes" :key="j">
                              <span v-if="!user">
                                <b-button
                                  v-if="
                                    aitem.freetimes.length === 1 &&
                                    aitem.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  08:30 - 12:00
                                </b-button>

                                <b-button
                                  v-if="
                                    aitem.freetimes.length === 1 &&
                                    aitem.status === 0 &&
                                    prod.time_begin === '16:30'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  13:00 -16:30
                                </b-button>

                                <b-button
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    prod.time_end !== '16:30'
                                  "
                                  variant="outline-pink"
                                  class="btn mb-1 mt-1 time-btn"
                                  v-b-modal="
                                    'modal-meeting-std-main' +
                                    aitem.room_id +
                                    prod.time_id
                                  "
                                  @click="getUsefor(aitem.room_id)"
                                >
                                  {{ prod.time_begin }} - {{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuse, iue) in historyall"
                                  :key="iue"
                                >
                                  <b-button
                                    v-if="
                                      timechkuse.room_id === aitem.room_id &&
                                      timechkuse.time_begin === '13:00' &&
                                      timechkuse.time_begin !==
                                        prod.time_begin &&
                                      aitem.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="btn mb-1 mt-1 time-btn"
                                  >
                                    13:00 -16:30
                                  </b-button>
                                </span>
                              </span>
                              <!-- END v-if == !user -->

                              <!-- Start v-if === !user -->
                              <!-- END v-if === User -->
                              <span v-if="user">
                                <b-button
                                  v-if="
                                    aitem.freetimes.length === 1 &&
                                    aitem.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  08:30 - 12:00
                                </b-button>

                                <b-button
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    (prod.time_end !== '16:30' &&
                                      aitem.freetimes.length !== 0)
                                  "
                                  pill
                                  variant="outline-pink"
                                  class="btn mb-1 mt-1 time-btn"
                                  href="/login"
                                >
                                  {{ prod.time_begin }} - {{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuser, iu) in historyall"
                                  :key="iu"
                                >
                                  <b-button
                                    v-if="
                                      timechkuser.room_id === aitem.room_id &&
                                      timechkuser.time_begin === '13:00' &&
                                      timechkuser.time_begin !==
                                        prod.time_begin &&
                                      aitem.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="btn mb-1 mt-1 time-btn"
                                  >
                                    13:00 - 16:30
                                  </b-button>
                                </span>
                              </span>
                              <!-- ============================= Modal ======================== -->
                              <!-- *************************** std manin************************* -->
                              <!-- v-if="chkbookingroom" -->
                              <b-modal
                                :hide-footer="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meeting-std-main' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="chkbookingroom"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ aitem.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>
                                <div
                                  class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        booking(
                                          aitem.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meeting-std-main' +
                                            aitem.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        (auth.isLibraryStaff === 1 &&
                                          aitem.floor !== 6) ||
                                        auth.LibraryStaff !== 1
                                      "
                                    >
                                      <!-- v-if="
                                  (auth.isLibraryStaff === 1 &&
                                    ![6].includes(aitem.floor)) ||
                                  auth.isLibraryStaff !== 1 -->

                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3 input-style"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>

                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        id=""
                                        v-model="input_another"
                                        v-if="[7, 13, 16].includes(selected)"
                                      />
                                      <p style="color: red">
                                        **หมายเหตุ : กรอกรหัสนักศึกษา
                                        {{ aitem.min_person }} คนขึ้นไป
                                      </p>
                                      <span
                                        style="color: red"
                                        v-if="error != '' || error === null"
                                      >
                                        **{{ error }}
                                      </span>
                                      <b-row>
                                        <b-col
                                          cols="6"
                                          v-for="(stdr, index) in 6"
                                          :key="index"
                                        >
                                          <input
                                            class="form-control input-style"
                                            placeholder="กรอกรหัสนักศึกษา"
                                            maxlength="11"
                                            v-model="values[index]"
                                          />
                                        </b-col>
                                      </b-row>

                                      <b-button
                                        :disabled="!isComplete"
                                        type="submit"
                                        class="btn btn-pink deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </b-button>
                                    </form>

                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          aitem.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meeting-std-main1' +
                                            aitem.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        auth.isLibraryStaff === 1 &&
                                        aitem.floor === 6
                                      "
                                    >
                                      <!-- v-if="
                                      auth.isLibraryStaff === 1 &&
                                      aitem.floor === 6
                                    " -->
                                      <!-- Teacher -->
                                      <span>
                                        <b-button variant="outline-primary">
                                          สำหรับอาจารย์
                                        </b-button>
                                      </span>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>

                                      <b-row>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="เบอร์โทรศัพท์"
                                            maxlength="10"
                                            v-model="input_room_Teacher_phone"
                                          />
                                        </b-col>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="ชื่อ - นามสกุล"
                                            v-model="input_room_Teacher_name"
                                            type="text"
                                            autocomplete=""
                                          />
                                        </b-col>
                                        <!-- options fac-->
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedfac"
                                            :options="optionsfac"
                                            value-field="fac_code"
                                            class="mb-3 input-style"
                                            text-field="fac_name"
                                            disabled-field="notEnabled"
                                            @change="get_branch()"
                                          >
                                            <!-- Teacher -->
                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                              >
                                                เลือกคณะ
                                              </b-form-select-option>
                                            </template>
                                          </b-form-select>
                                        </b-col>
                                        <!-- option branch -->
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedbranch"
                                            :options="optionsbranch"
                                            class="mb-3 input-style"
                                            value-field="branch_code"
                                            text-field="branch_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->
                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                              >
                                                เลือกสาขา
                                              </b-form-select-option>
                                            </template>
                                          </b-form-select>
                                        </b-col>

                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="อีเมล"
                                            maxlength=""
                                            type="email"
                                            v-model="input_room_Teacher_email"
                                          />
                                        </b-col>

                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selected"
                                            :options="options"
                                            class="mb-3 input-style"
                                            value-field="usefor_id"
                                            text-field="usefor_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->
                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                              >
                                                เลือกวัตถุประสงค์การใช้งาน
                                              </b-form-select-option>
                                            </template>
                                          </b-form-select>
                                          <input
                                            type="text"
                                            class="form-control input-style"
                                            placeholder="กรอกวัตถุประสงค์"
                                            v-model="input_another"
                                            v-if="
                                              [7, 13, 16].includes(selected)
                                            "
                                          />
                                        </b-col>
                                      </b-row>
                                    </form>

                                    <button
                                      v-if="
                                        auth.isLibraryStaff === 1 &&
                                        [6].includes(aitem.floor)
                                      "
                                      :disabled="!isCompleteAnothor"
                                      type="submit"
                                      class="btn btn-pink deep-purple btn-block badge-pill"
                                      data-dismiss="modal"
                                      @click="showModal = false"
                                    >
                                      ยืนยัน
                                    </button>
                                  </div>
                                </div>
                              </b-modal>

                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meeting-std-main' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i
                                    >{{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>

                              <!-- *************************** END ****************************** -->
                              <!-- ============================= END ======================== -->
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                </span>

                <!-- ############################# END ########################## -->
              </span>
            </div>
            <!-- </span> -->

            <!-- END -->

            <!-- อาคาร 14 -->
            <div class="card-room" v-if="buildings[activeIndex].detail == 1">
              <!-- Teacher อาคาร 14 -->
              <span v-for="(aitem, index) in itembd" :key="index">
                <!-- *************** ห้องกลุ่มย่อย 2 3 4 5 *********************** -->
                <span v-if="!isShowstaff">
                  <div class="card-input">
                    <div
                      class="top-50 start-50 translate-middle"
                      v-if="[1, 2, 3, 4, 5, 6].includes(aitem.room_id)"
                    >
                      <div
                        class="animate__animated animate bounce card card-detail-tebs"
                        style="width: 18rem"
                      >
                        <div class="container mt-3 container-img">
                          <img
                            v-if="aitem.room_id === 1"
                            src="../../assets/meetingrooms/2A.jpeg"
                            alt=""
                            class="card-img-top"
                          />

                          <img
                            v-if="aitem.room_id === 2"
                            src="../../assets/meetingrooms/2B.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <img
                            v-if="aitem.room_id === 3"
                            src="../../assets/meetingrooms/3A.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <img
                            v-if="aitem.room_id === 4"
                            src="../../assets/meetingrooms/3B.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <img
                            v-if="aitem.room_id === 5"
                            src="../../assets/meetingrooms/4A.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <img
                            v-if="aitem.room_id === 6"
                            src="../../assets/meetingrooms/4B.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <!-- <img
                            v-if="aitem.room_id === 7"
                            src="../../assets/meetingrooms/5C.jpeg"
                            alt=""
                            class="card-img-top"
                          /> -->
                        </div>

                        <div class="card-body">
                          <h5 class="card-title ms-1">
                            <b>{{ aitem.room_name }}</b>
                          </h5>
                          <p class="card-text mb-3 ms-1 detail-size-text">
                            <i class="fa-solid fa-location-dot"></i>
                            {{ aitem.room_desc }}
                          </p>

                          <span
                            v-if="
                              aitem.status === 1 ||
                              (aitem.status === 0 &&
                                aitem.freetimes.length === 0)
                            "
                          >
                            <b-button
                              class="btn mb-1 mt-1 time-btn"
                              pill
                              variant="outline-secondary"
                              disabled
                            >
                              08:30 - 12:00
                            </b-button>
                            <b-button
                              class="btn mb-1 mt-1 time-btn"
                              pill
                              variant="outline-secondary"
                              disabled
                            >
                              13:00 - 16:30
                            </b-button>
                          </span>

                          <span v-for="(prod, j) of aitem.freetimes" :key="j">
                            <!-- v-if='!user' Teacher -->
                            <span v-if="!user">
                              <b-button
                                v-if="
                                  aitem.freetimes.length === 1 &&
                                  aitem.status === 0 &&
                                  prod.time_begin === '13:00'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="btn mb-1 mt-1 time-btn"
                              >
                                08:30 - 12:00
                              </b-button>

                              <b-button
                                v-if="
                                  prod.time_begin !== '08:30' ||
                                  prod.time_end !== '16:30'
                                "
                                variant="outline-pink"
                                v-b-modal="
                                  'modal-a14-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                class="btn mb-1 mt-1 time-btn"
                                @click="getUsefor(aitem.room_id)"
                                pill
                              >
                                {{ prod.time_begin }} - {{ prod.time_end }}
                              </b-button>
                              <!--  -->
                              <span
                                v-for="(timechkuser, iu) in historyall"
                                :key="iu"
                              >
                                <b-button
                                  v-if="
                                    timechkuser.room_id === aitem.room_id &&
                                    timechkuser.time_begin === '13:00' &&
                                    timechkuser.time_begin !==
                                      prod.time_begin &&
                                    aitem.freetimes.length === 1
                                  "
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  13:00 - 16:30
                                </b-button>
                              </span>

                              <!-- *********************************  MODAL Meeting A 14 === 'modal-a14-meetingAnother' ************************-->
                              <b-modal
                                :hide-footer="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-a14-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="chkbookingroom"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow border-light"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ aitem.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>
                                <!-- end -->
                                <div
                                  class="card card-order-list card-margin shadow border-light"
                                >
                                  <div class="card-body">
                                    <form
                                      action=""
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          aitem.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-a14-meetingAnother' +
                                            aitem.room_id +
                                            prod.time_id
                                        )
                                      "
                                    >
                                      <p style="color: blue">
                                        *หมายเหตุ :
                                        กรุณาเลือกวัตุประสงค์การใช้งาน
                                      </p>
                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                        class="mb-3 input-style"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                          >
                                            เลือกวัตถุประสงค์การใช้งาน
                                          </b-form-select-option>
                                        </template>
                                      </b-form-select>

                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />
                                      <b-button
                                        :disabled="!isCompleteTeach"
                                        type="submit"
                                        class="btn btn-pink deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน 
                                      </b-button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <!-- จองห้องแล้ว จะขึ้น modal นี้ -->
                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-a14-meetingAnother' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i>
                                    {{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                              <!-- END  -->

                              <!-- ********************************* END  MODAL Meeting A 14 === 'modal-a14-meetingAnother' ************************-->
                            </span>
                            <!-- END  !user-->

                            <!-- v-if ='user' -->

                            <!-- END v-if ='user' -->
                            <!-- **************************** MODAL Meeting A 14  == modal-a14-teacher-meeting ************************************ -->

                            <!-- **************************** END  MODAL Meeting A 14 ************************************ -->
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>

                <!-- *************** END ห้องกลุ่มย่อย 2 3 4 5 *********************** -->

                <!-- END Teacher -->

                <!-- STUDENT อาคาร 14-->
                <span v-if="isShowstaff">
                  <div class="card-input">
                    <div
                      class="top-50 start-50 translate-middle"
                      v-if="[1, 2, 3, 4, 5, 6].includes(aitem.room_id)"
                    >
                      <div
                        class="animate__animated animate bounce card card-detail-tebs"
                        style="width: 18rem"
                      >
                        <div class="container mt-3 container-img">
                          <img
                            v-if="aitem.room_id === 1"
                            src="../../assets/meetingrooms/2A.jpeg"
                            alt=""
                            class="card-img-top"
                          />

                          <img
                            v-if="aitem.room_id === 2"
                            src="../../assets/meetingrooms/2B.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <img
                            v-if="aitem.room_id === 3"
                            src="../../assets/meetingrooms/3A.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <img
                            v-if="aitem.room_id === 4"
                            src="../../assets/meetingrooms/3B.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <img
                            v-if="aitem.room_id === 5"
                            src="../../assets/meetingrooms/4A.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <img
                            v-if="aitem.room_id === 6"
                            src="../../assets/meetingrooms/4B.jpeg"
                            alt=""
                            class="card-img-top"
                          />
                          <!-- <img
                            v-if="aitem.room_id === 7"
                            src="../../assets/meetingrooms/5C.jpeg"
                            alt=""
                            class="card-img-top"
                          /> -->
                        </div>

                        <div class="card-body">
                          <h5 class="card-title ms-1">
                            <b>{{ aitem.room_name }}</b>
                          </h5>
                          <p class="card-text mb-3 ms-1 detail-size-text">
                            <i class="fa-solid fa-location-dot"></i>
                            {{ aitem.room_desc }}
                          </p>

                          <span
                            v-if="
                              aitem.status === 1 ||
                              (aitem.status === 0 &&
                                aitem.freetimes.length === 0)
                            "
                          >
                            <b-button
                              class="btn mb-1 mt-1 time-btn"
                              pill
                              variant="outline-secondary"
                              disabled
                            >
                              08:30 - 12:00
                            </b-button>
                            <b-button
                              class="btn mb-1 mt-1 time-btn"
                              pill
                              variant="outline-secondary"
                              disabled
                            >
                              13:00 - 16:30
                            </b-button>
                          </span>
                          <!--  -->
                          <!-- <pre>{{ JSON.stringify(user, null, 2) }}</pre> -->
                          <span v-for="(prod, j) in aitem.freetimes" :key="j">
                            <!--เข้าสู่ระบบ -->
                            <!-- Start !user STD-->

                            <span v-if="!user">
                              <!-- <h1>user == flase</h1> -->
                              <b-button
                                v-if="
                                  aitem.freetimes.length === 1 &&
                                  aitem.status === 0 &&
                                  prod.time_begin === '13:00'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="btn mb-1 mt-1 time-btn"
                              >
                                08:00 - 12:00
                              </b-button>
                              <b-button
                                v-if="
                                  aitem.freetimes.length === 1 &&
                                  aitem.status == 0 &&
                                  prod.time_begin === '16:30'
                                "
                                pill
                                variant="outline-secondary"
                                class="btn mt-1 mb-1 time-btn"
                              >
                                13:00 - 16:30
                              </b-button>

                              <b-button
                                v-if="
                                  prod.time_begin !== '08:30' ||
                                  prod.time_end !== '16:30'
                                "
                                variant="outline-pink"
                                v-b-modal="
                                  'modal-a14-std-meetingMain' +
                                  aitem.room_id +
                                  prod.time_id
                                "
                                class="btn mb-1 mt-1 time-btn"
                                @click="getUsefor(aitem.room_id)"
                              >
                                {{ prod.time_begin }} - {{ prod.time_end }}
                              </b-button>

                              <span
                                v-for="(timechkuse, iue) in historyall"
                                :key="iue"
                              >
                                <b-button
                                  v-if="
                                    timechkuse.room_id === aitem.room_id &&
                                    timechkuse.time_begin === '13:00' &&
                                    timechkuse.time_begin !== prod.time_begin &&
                                    aitem.freetimes.length === 1
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  13:00 - 16:30
                                </b-button>
                              </span>
                            </span>
                            <!-- END v-if ='!user' -->

                            <!-- start v-if='user' -->
                            <!-- ยังไม่ได้ เข้าสู่ระบบ -->
                            <span v-if="user">
                              <!-- <h1> user == true</h1> -->

                              <b-button
                                v-if="
                                  aitem.freetimes.length === 1 &&
                                  aitem.status === 0 &&
                                  prod.time_begin === '13:00'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="btn mb-1 mt-1 time-btn"
                              >
                                08:30 - 12:00
                              </b-button>

                              <b-button
                                v-if="
                                  prod.time_begin !== '08:30' ||
                                  (prod.time_end !== '16:30' &&
                                    aitem.freetimes.length !== 0)
                                "
                                pill
                                variant="outline-pink"
                                class="btn mb-1 mt-1 time-btn"
                                href="/login"
                              >
                                {{ prod.time_begin }} - {{ prod.time_end }}
                              </b-button>

                              <b-button
                                v-if="
                                  aitem.freetimes.length === 1 &&
                                  prod.time_begin === '08:30'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="btn mb-1 mt-1 time-btn"
                              >
                                13:00 -16:30
                              </b-button>
                              <span
                                v-for="(timechkuser, iu) in historyall"
                                :key="iu"
                              >
                                <b-button
                                  v-if="
                                    timechkuser.room_id === aitem.room_id &&
                                    timechkuser.time_begin === '08:30' &&
                                    timechkuser.time_begin !==
                                      prod.time_begin &&
                                    aitem.freetimes.length === 1
                                  "
                                  variant="outline-secondary"
                                  disabled
                                  class="btn mb-1 mt-1 time-btn"
                                >
                                  13:00 - 16:30
                                </b-button>
                              </span>
                            </span>
                            <!-- end  v-if='user' -->

                            <!-- ********************* MODAL = modal-a14-std-meetingMain **************************** -->
                            <b-modal
                              :hide-footer="true"
                              v-if="chkbookingroom"
                              centered
                              size="lg"
                              header-border-variant="white"
                              :id="
                                'modal-a14-std-meetingMain' +
                                aitem.room_id +
                                prod.time_id
                              "
                              class="border-bottom-0"
                            >
                              <template #modal-title>
                                <div
                                  class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                >
                                  <div class="card-body">
                                    <i class="fa-solid fa-bookmark"></i>
                                    ห้อง {{ aitem.room_name }} เวลาจอง
                                    {{ prod.time_begin }} -
                                    {{ prod.time_end }}
                                  </div>
                                </div>
                              </template>
                              <!--  -->
                              <div
                                class="card card-order-list card-margin shadow-sm border-light card-time-title"
                              >
                                <div class="card-body">
                                  <form
                                    action=""
                                    class="form-group"
                                    @submit.prevent="
                                      booking(
                                        aitem.room_id,
                                        prod.time_begin,
                                        prod.time_end,
                                        prod.time_id,
                                        'modal-a14-std-meetingMain' +
                                          aitem.room_id +
                                          prod.time_id
                                      )
                                    "
                                    v-if="
                                      (auth.isLibraryStaff === 1 &&
                                        aitem.floor !== 6) ||
                                      auth.LibraryStaff !== 1
                                    "
                                  >
                                    <b-form-select
                                      class="mb-3 input-style"
                                      v-model="selected"
                                      :options="options"
                                      value-field="usefor_id"
                                      text-field="usefor_name"
                                      disabled-field="notEnabled"
                                    >
                                      <template #first>
                                        <b-form-select-option
                                          :value="null"
                                          disabled
                                        >
                                          เลือกวัตถุประสงค์การใช้งาน
                                        </b-form-select-option>
                                      </template>
                                    </b-form-select>
                                    <!-- Input -->
                                    <input
                                      type="text"
                                      class="form-control input-style"
                                      placeholder="กรอกวัตถุประสงค์"
                                      v-model="input_anather"
                                      v-if="
                                        selected === 7 ||
                                        selected === 13 ||
                                        selected === 16
                                      "
                                    />
                                    <!-- end -->
                                    <p style="color: red">
                                      **หมายเหตุ : กรอกรหัสนักศึกษา
                                      {{ aitem.min_person }} คนขึ้นไป
                                    </p>
                                    <!-- ERROR -->
                                    <span
                                      style="color: red"
                                      v-if="error != '' || error === null"
                                    >
                                      **{{ error }}
                                    </span>
                                    <!-- end -->

                                    <b-row>
                                      <b-col
                                        cols="6"
                                        v-for="(stdr, index) in input_stdcode"
                                        :key="index"
                                      >
                                        <input
                                          class="form-control input-style"
                                          placeholder="กรอกรหัสนักศึกษา"
                                          maxlength="11"
                                          v-model="values[index]"
                                        />
                                      </b-col>
                                    </b-row>
                                    <!-- end b-row -->
                                    <b-button
                                      :disabled="!isComplete"
                                      type="submit"
                                      class="btn btn-pink deep-purple btn-block badge-pill"
                                      data-dismiss="modal"
                                      @click="showModel = false"
                                    >
                                      ยืนยัน
                                    </b-button>
                                  </form>
                                  <!-- end form 01 -->

                                  <!-- Start Teacher form-->

                                  <!-- END Teacher form-->
                                </div>
                              </div>
                            </b-modal>
                            <!-- หากจองห้องไปแล้วให้แจ้งเตือน modal นี้  -->
                            <b-modal
                              :hide-footer="true"
                              :hide-header="true"
                              centered
                              size="lg"
                              :id="
                                'modal-a14-std-meetingMain' +
                                aitem.room_id +
                                prod.time_id
                              "
                              class="border-bottom-0"
                              v-if="!chkbookingroom"
                            >
                              <div
                                class="card-body justify-content-center card-blok p-3 text-center text-danger"
                              >
                                <h5>
                                  <i class="fa-solid fa-circle-exclamation"></i
                                  >{{ msgbookingroom }}
                                </h5>
                              </div>
                            </b-modal>

                            <!-- END -->

                            <!-- ******************** END  MODAL = modal-a14-std-meetingMain ***********************-->
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </span>
            </div>
            <!-- END -->
          </div>
        </div>

        <!-- ******************** END Meeting Room Detail **************-->

        <!-- ###################### STUDIO ############################# -->
        <div class="detail" v-if="radio_btn === 'studio'">
          <!-- *************** ห้อง STUDIO*********************** -->
          <template
            v-if="
              buildings[activeIndex].detail == 0 &&
              ['Sa', 'Su'].includes(choosedDay2.day)
            "
          >
            <div class="card-columns">
              <div class="card-input">
                <div
                  class="card card-order-list card-margin border-0 card-service"
                >
                  <div class="card-body">
                    <i
                      class="fa-solid fa-circle-exclamation fa-1x"
                      style="color: #bc060f"
                    ></i>
                    สามารถจอง <b>ห้องสตูดิโอ 1,2</b> ได้ในวันทำการ จันทร์ -
                    ศุกร์ ขออภัยในความไม่สะดวก
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="card-room" v-else>
            <span v-for="(aitem, index) in itembd" :key="index">
              <!-- v-if === TEACHER  -->
              <span v-if="!isShowstaff">
                <div class="card-input">
                  <div
                    class="top-50 start-50 translate-middle"
                    v-if="[8,9].includes(aitem.room_id)"
                  >
                   <!-- v-if="[8, 9].includes(aitem.room_id)" -->
                    <div
                      class="animate__animated animate bounce card card-detail-tebs"
                      style="width: 18rem"
                    >
                      <!-- img -->
                      <div class="container mt-3 container-img">
                        <img
                          v-if="aitem.room_id === 8"
                          src="../../assets/meetingrooms/stu1.jpeg"
                          alt=""
                          class="card-img-top"
                        />

                        <img
                          v-if="aitem.room_id === 9"
                          src="../../assets/meetingrooms/stu2.jpeg"
                          alt=""
                          class="card-img-top"
                        />
                      </div>
                      <!-- end img -->

                      <div class="card-body">
                        <h5 class="card-title ms-1">
                          <b>{{ aitem.room_name }}</b>
                        </h5>
                        <p class="card-text mb-3 ms-1 detail-size-text">
                          <i class="fa-solid fa-location-dot"></i>
                          {{ aitem.room_desc }}
                        </p>

                        <span
                          v-if="
                            aitem.status === 1 ||
                            (aitem.status === 0 && aitem.freetimes.length === 0)
                          "
                        >
                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            08:30 - 12:00
                          </b-button>
                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            13:00 - 16:30
                          </b-button>
                        </span>

                        <span v-for="(prod, j) of aitem.freetimes" :key="j">
                          <b-button
                            v-if="
                              aitem.freetimes.length === 1 &&
                              aitem.status === 0 &&
                              prod.time_begin === '13:00'
                            "
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            08:30 - 12:00
                          </b-button>

                          <b-button
                            v-if="
                              prod.time_begin !== '08:30' ||
                              prod.time_end !== '16:30'
                            "
                            class="btn mb-1 mt-1 time-btn"
                            variant="outline-pink"
                            v-b-modal="
                              'modal-studio-meetingAnother' +
                              aitem.room_id +
                              prod.time_id
                            "
                            @click="getUsefor(aitem.room_id)"
                          >
                            {{ prod.time_begin }} - {{ prod.time_end }}
                          </b-button>

                          <span
                            v-for="(timechkuse, iu) in historyall"
                            :key="iu"
                          >
                            <b-button
                              v-if="
                                timechkuse.room_id === aitem.room_id &&
                                timechkuse.time_begin === '13:00' &&
                                timechkuse.time_begin !== prod.time_begin &&
                                aitem.freetimes.length === 1
                              "
                              class="btn mb-1 mt-1 time-btn"
                              pill
                              variant="outline-secondary"
                              disabled
                            >
                              13:00 - 16:30
                            </b-button>
                          </span>
                          <!-- end -->
                          <!-- ************************************************* MODAL =  modal-studio-meetingAnother ************************************-->
                          <b-modal
                            class="border-bottom-0"
                            :hide-footer="true"
                            centered
                            size="lg"
                            :id="
                              'modal-studio-meetingAnother' +
                              aitem.room_id +
                              prod.time_id
                            "
                            header-border-variant="white"
                          >
                            <template #modal-title>
                              <div
                                class="card card-order-list card-margin shadow border-light"
                              >
                                <div class="card-body">
                                  <i class="fa-solid fa-bookmark"></i>
                                  ห้อง {{ aitem.room_name }} เวลาจอง
                                  {{ prod.time_begin }} -
                                  {{ prod.time_end }}
                                </div>
                              </div>
                            </template>

                            <div
                              class="card card-order-list card-margin shadow border-light"
                            >
                              <div class="card-body">
                                <form
                                  action=""
                                  class="form-group"
                                  @submit.prevent="
                                    bookingAnother(
                                      aitem.room_id,
                                      prod.time_begin,
                                      prod.time_end,
                                      prod.time_id +
                                        'modal-studio-meetingAnother' +
                                        aitem.room_id +
                                        prod.time_id
                                    )
                                  "
                                >
                                  <p style="color: red">
                                    *หมายเหตุ : กรุณาเลือกวัตุประสงค์การใช้งาน
                                  </p>

                                  <b-form-select
                                    class="mb-3 input-style"
                                    v-model="selected"
                                    :options="options"
                                    value-field="usefor_id"
                                    text-field="usefor_name"
                                    disabled-field="notEnabled"
                                  >
                                    <template #first>
                                      <b-form-select-option
                                        :value="null"
                                        disabled
                                      >
                                        เลือกวัตถุประสงค์การใช้งาน
                                      </b-form-select-option>
                                    </template>
                                  </b-form-select>
                                  <!-- end  b-form-select-->
                                  <span
                                    style="color: red; font-weight: bold"
                                    v-if="error != '' || error === null"
                                  >
                                    ERROR :{{ error }}
                                    <br />
                                    <br />
                                  </span>
                                  <input
                                    type="text"
                                    class="form-control input-style"
                                    placeholder="กรอกวัตถุประสงค์"
                                    v-model="input_another"
                                    v-if="
                                      selected === 7 ||
                                      selected === 13 ||
                                      selected === 16
                                    "
                                  />
                                  <b-button
                                    class="btn btn-pink deep-purple btn-block badge-pill"
                                    :disabled="!isCompleteTeach"
                                    type="submit"
                                    data-dismiss="modal"
                                    @click="showModal = false"
                                  >
                                    ยืนยัน
                                  </b-button>
                                </form>
                              </div>
                            </div>
                          </b-modal>

                          <!-- ************************************************ END   MODAL =   modal-studio-meetingAnother *****************************-->
                          <!-- ################################################ เมื่อมีการจองห้องแล้ว จะ Show modal นี้ ############################## -->
                          <b-modal
                            class="border-bottom-0"
                            :hide-footer="true"
                            :hide-header="true"
                            centered
                            size="lg"
                            :id="
                              'modal-studio-meetingAnother' +
                              aitem.room_id +
                              prod.time_id
                            "
                            header-border-variant="white"
                            v-if="!chkbookingroom"
                          >
                            <div
                              class="card-body justify-content-center card-block p-3 text-center text-danger"
                            >
                              <h5>
                                <i class="fa-solid fa-circle-exclamation"></i>
                                {{ msgbookingroom }}
                              </h5>
                            </div>
                          </b-modal>
                          <!-- #### END #### -->
                        </span>
                      </div>
                      <!-- end card-body -->
                    </div>
                  </div>
                </div>
              </span>
              <!--  END v-if === TEACHER  -->
              <!-- v-if === STD  -->

              <span v-if="isShowstaff">
                <div class="card-input">
                  <div
                    class="top-50 start-50 translate-middle"
                    v-if="[8,9].includes(aitem.room_id)"
                  >
                   <!-- v-if="[8, 9].includes(aitem.room_id)" -->
                    <div
                      class="animate__animated animate bounce card card-detail-tebs"
                      style="width: 18rem"
                    >
                      <!-- img -->
                      <div class="container mt-3 container-img">
                        <img
                          v-if="aitem.room_id === 8"
                          src="../../assets/meetingrooms/stu1.jpeg"
                          alt=""
                          class="card-img-top"
                        />

                        <img
                          v-if="aitem.room_id === 9"
                          src="../../assets/meetingrooms/stu2.jpeg"
                          alt=""
                          class="card-img-top" 
                        />
                      </div>
                      <!-- end img -->

                      <div class="card-body">
                        <h5 class="card-title">
                          <b>{{ aitem.room_name }}</b>
                        </h5>
                        <p class="card-text mb-3 ms-1 detail-size-text">
                          <i class="fa-solid fa-location-dot"></i>
                          {{ aitem.room_desc }}
                        </p>
                        <!--  -->
                        <span
                          v-if="
                            aitem.status === 1 ||
                            (aitem.status === 0 && aitem.freetimes.length === 0)
                          "
                        >
                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            08:30 - 12:00
                          </b-button>
                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            13:00 - 16:30
                          </b-button>
                        </span>
                        <!--  -->
                        <span v-for="(prod, j) of aitem.freetimes" :key="j">
                          <span v-if="!user">
                            <b-button
                              class="btn mb-1 mt-1 time-btn"
                              v-if="
                                aitem.freetimes.length === 1 &&
                                aitem.status === 0 &&
                                prod.time_begin === '13:00'
                              "
                              variant="outline-secondary"
                              disabled
                              pill
                            >
                              08:30 - 12:00
                            </b-button>

                            <b-button
                              class="btn mb-1 mt-1 time-btn"
                              variant="outline-secondary"
                              v-if="
                                aitem.freetimes.length === 1 &&
                                aitem.status === 0 &&
                                prod.time_begin === '16:30'
                              "
                              pill
                              disabled
                            >
                              13:00 - 16:30
                            </b-button>

                            <b-button
                              class="btn mb-1 mt-1 time-btn"
                              variant="outline-pink"
                              v-b-modal="
                                'modal-studio-std' +
                                aitem.room_id +
                                prod.time_id
                              "
                              @click="getUsefor(aitem.room_id)"
                              v-if="
                                prod.time_begin !== '08:30' ||
                                prod.time_end !== '16:30'
                              "
                            >
                              {{ prod.time_begin }} - {{ prod.time_end }}
                            </b-button>

                            <span
                              v-for="(timechkuse, iue) in historyall"
                              :key="iue"
                            >
                              <b-button
                                class="btn mb-1 mt-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                                v-if="
                                  timechkuse.room_id === aitem.room_id &&
                                  timechkuse.time_begin === '13:00' &&
                                  timechkuse.time_begin !== prod.time_begin &&
                                  aitem.freetimes.length === 1
                                "
                              >
                                13:00 - 16:30
                              </b-button>
                            </span>
                          </span>
                          <!-- END !user -->

                          <!-- if = user -->
                          <span v-if="user">
                            <b-button
                              class="btn mt-1 mb-1 time-btn"
                              variant="outline-secondary"
                              pill
                              disabled
                              v-if="
                                aitem.freetimes.length === 1 &&
                                aitem.status === 0 &&
                                prod.time_begin === '13:00'
                              "
                            >
                              08:30 - 12:00
                            </b-button>

                            <b-button
                              class="btn mt-1 mb-1 time-btn"
                              pill
                              variant="outline-pink"
                              href="/login"
                              v-if="
                                prod.time_begin !== '08:30' ||
                                (prod.time_end !== '16:30' &&
                                  aitem.freetimes.length !== 0)
                              "
                            >
                              {{ prod.time_begin }} - {{ prod.time_end }}
                            </b-button>
                            <b-button
                              v-if="
                                aitem.freetimes.length === 1 &&
                                prod.time_begin === '08:30'
                              "
                              pill
                              variant="outline-secondary"
                              disabled
                              class="btn mb-1 mt-1 time-btn"
                            >
                              13:00 -16:30
                            </b-button>
                            <span
                              v-for="(timechkuse, iu) in historyall"
                              :key="iu"
                            >
                              <b-button
                                class="btn mt-1 mb-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                                v-if="
                                  timechkuse.room_id === aitem.room_id &&
                                  timechkuse.time_begin === '13:00' &&
                                  timechkuse.time_begin !== prod.time_begin &&
                                  aitem.freetimes.length === 1
                                "
                              >
                                13:00 - 16:30
                              </b-button>
                            </span>
                          </span>
                          <!-- END USER -->
                          <!-- ============================================ MODAL = modal-studio-std ============================== -->
                          <b-modal
                            class="border-bottom-0"
                            v-if="chkbookingroom"
                            :hide-footer="true"
                            centered
                            size="lg"
                            :id="
                              'modal-studio-std' + aitem.room_id + prod.time_id
                            "
                            header-border-variant="white"
                          >
                            <template #modal-title>
                              <div
                                class="card card-order-list card-margin shadow-sm border-light card-time-title"
                              >
                                <div class="card-body">
                                  <i class="fa-solid fa-bookmark"></i>
                                  ห้อง {{ aitem.room_name }} เวลาจอง
                                  {{ prod.time_begin }} -
                                  {{ prod.time_end }}
                                </div>
                              </div>
                            </template>

                            <div
                              class="card card-order-list card-margin shadow-sm border-light card-time-body"
                            >
                              <div class="card-body">
                                <form
                                  action=""
                                  class="form-group"
                                  @submit.prevent="
                                    booking(
                                      aitem.room_id,
                                      prod.time_begin,
                                      prod.time_end,
                                      prod.time_id,
                                      'modal-studio-std' + aitem.room_id,
                                      prod.time_id
                                    )
                                  "
                                  v-if="
                                    (auth.isLibraryStaff === 1 &&
                                      aitem.floor !== 6) ||
                                    auth.isLibraryStaff !== 1
                                  "
                                >
                                  <b-form-select
                                    class="mb-3 input-style"
                                    v-model="selected"
                                    :options="options"
                                    value-field="usefor_id"
                                    text-field="usefor_name"
                                    disabled-field="notEnabled"
                                  >
                                    <template #first>
                                      <b-form-select-option
                                        :value="null"
                                        disabled
                                      >
                                        เลือกวัตถุประสงค์การใช้งาน
                                      </b-form-select-option>
                                    </template>
                                  </b-form-select>

                                  <input
                                    type="text"
                                    class="form-control input-style"
                                    placeholder="กรอกวัตถุประสงค์"
                                    v-model="input_another"
                                    v-if="
                                      selected === 7 ||
                                      selected === 13 ||
                                      selected === 16
                                    "
                                  />
                                  <p style="color: red">
                                    **หมายเหตุ : กรอกรหัสนักศึกษา
                                    {{ aitem.min_person }} คนขึ้นไป
                                  </p>
                                  <span
                                    style="color: red"
                                    v-if="error != '' || error === null"
                                  >
                                    **{{ error }}
                                  </span>

                                  <b-row>
                                    <b-col
                                      cols="6"
                                      v-for="(stdr, index) in input_stdcode"
                                      :key="index"
                                    >
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกรหัสนักศึกษา"
                                        maxlength="11"
                                        v-model="values[index]"
                                      />
                                    </b-col>
                                  </b-row>

                                  <b-button
                                    class="btn btn-pink deep-purple btn-block badge-pill"
                                    :disabled="!isComplete"
                                    type="submit"
                                    data-dismiss="modal"
                                    @click="showModal = false"
                                  >
                                    ยืนยัน
                                  </b-button>
                                </form>

                                <form
                                  action=""
                                  class="form-group"
                                  @submit.prevent="
                                    bookingAnother(
                                      aitem.room_id,
                                      prod.time_begin,
                                      prod.time_end,
                                      prod.time_id,
                                      'modal-studio-std' + aitem.room_id,
                                      prod.time_id
                                    )
                                  "
                                  v-if="
                                    auth.isLibraryStaff === 1 &&
                                    aitem.floor === 6
                                  "
                                >
                                  <span>
                                    <b-button variant="outline-primary">
                                      สำหรับอาจารย์
                                    </b-button>
                                  </span>

                                  <span
                                    style="color: red; font-weight: bold"
                                    v-if="error != '' || error === null"
                                  >
                                    ERROR : {{ error }}
                                    <br />
                                    <br />
                                  </span>

                                  <b-row>
                                    <b-col cols="6">
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="เบอร์โทรศัพท์"
                                        v-model="input_room_Teacher_phone"
                                      />
                                    </b-col>
                                    <b-col cols="6">
                                      <input
                                        class="form-control input-style"
                                        placeholder="ชื่อ - นามสกุล"
                                        v-model="input_room_Teacher_name"
                                        autocomplete
                                      />
                                    </b-col>
                                    <!-- fac -->
                                    <b-col cols="6">
                                      <b-form-select
                                        class="mb-3 input-style"
                                        v-model="selectedfac"
                                        :options="optionsfac"
                                        value-field="fac_code"
                                        text-field="fac_name"
                                        disabled-field="notEnabled"
                                        @change="get_branch()"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                          >
                                            เลือกคณะ
                                          </b-form-select-option>
                                        </template>
                                      </b-form-select>
                                    </b-col>
                                    <!-- end fac -->
                                    <!-- branch -->
                                    <b-col cols="6">
                                      <b-form-select
                                        v-model="selectedbranch"
                                        :options="optionsbranch"
                                        class="mb-3 input-style"
                                        value-field="branch_code"
                                        text-field="branch_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                          >
                                            เลือกสาขา
                                          </b-form-select-option>
                                        </template>
                                      </b-form-select>
                                    </b-col>
                                    <!-- end branch -->
                                    <b-col cols="6">
                                      <input
                                        type="email"
                                        class="form-control input-style"
                                        placeholder="อีเมล"
                                        maxlength=""
                                        v-model="input_room_Teacher_email"
                                      />
                                    </b-col>

                                    <b-col cols="6">
                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3 input-style"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                          >
                                            เลือกวัตถุประสงค์การใช้งาน
                                          </b-form-select-option>
                                        </template>
                                      </b-form-select>

                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />
                                    </b-col>
                                  </b-row>
                                  <!-- BTN -->

                                  <b-button
                                    class="btn btn-pink deep-purple btn-block"
                                    pill
                                    :disabled="!isCompleteAnothor"
                                    v-if="
                                      auth.isLibraryStaff === 1 &&
                                      aitem.floor === 6
                                    "
                                    type="submit"
                                    data-dismiss="modal"
                                    @click="showModal = false"
                                  >
                                    ยืนยัน
                                  </b-button>
                                </form>
                              </div>
                            </div>

                            <!-- STD -->
                            <!-- END STD -->

                            <!-- TEACHER -->
                            <!-- END TEACHER -->
                          </b-modal>

                          <!--  ============================================ END MODAL = modal-studio-std  ============================================-->
                          <!-- ********************************************** MODAL = modal-studio-std  เมื่อมีการจองห้องแล้ว ระบบจะทำการโชว์ข้อมูลส่วนนี้ ********************************************** -->
                          <b-modal
                            class="border-bottom-0"
                            :hide-footer="true"
                            :hide-header="true"
                            centered
                            size="lg"
                            :id="
                              'modal-studio-std' + aitem.room_id + prod.time_id
                            "
                            header-border-variant="white"
                            v-if="!chkbookingroom"
                          >
                            <div
                              class="card-body justify-content-center card-block p-3 text-center text-danger"
                            >
                              <h5>
                                <i class="fa-solid fa-circle-exclamation"></i>
                                {{ msgbookingroom }}
                              </h5>
                            </div>
                          </b-modal>
                          <!-- ********************************************** END MODAL =modal-studio-std  เมื่อมีการจองห้องแล้ว ระบบจะทำการโชว์ข้อมูลส่วนนี้ ********************************************** -->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
              <!-- END v-if === STD  -->
            </span>
          </div>

          <!-- *************** END STUDIO *********************** -->
        </div>
        <!-- ##################### END STUDIO ######################### -->

        <!-- ************************ ห้องบันทึกเสียง ********************* -->

        <div class="detail" v-if="radio_btn === 'racord'">
          <!-- *************** ห้อง บันทึกเสียง *********************** -->
          <template
            v-if="
              buildings[activeIndex].detail == 0 &&
              ['Sa', 'Su'].includes(choosedDay2.day)
            "
          >
            <div class="card-columns">
              <div class="card-input">
                <div
                  class="card card-order-list card-margin border-0 card-service"
                >
                  <div class="card-body">
                    <i
                      class="fa-solid fa-circle-exclamation fa-1x"
                      style="color: #bc060f"
                    ></i>
                    สามารถจอง <b>ห้องบันทึกเสียง</b> ได้ในวันทำการ จันทร์ -
                    ศุกร์ ขออภัยในความไม่สะดวก
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="card-room" v-else>
            <span v-for="(aitem, index) in itembd" :key="index">
              <!-- TEACHER -->
              <span v-if="!isShowstaff">
                <div class="card-input">
                  <div
                    class="top-50 start-50 translate-middle"
                    v-if="aitem.room_id === 10"
                  >
                    <div
                      class="animate__animated animate bounce card card-detail-tebs"
                      style="width: 18rem"
                    >
                      <!-- img -->
                      <div class="container mt-3 container-img">
                        <img
                          src="../../assets/meetingrooms/rac.jpeg"
                          alt=""
                          class="card-img-top"
                          v-if="aitem.room_id === 10"
                        />
                      </div>
                      <!-- endimg -->
                      <div class="card-body">
                        <!-- text img -->
                        <h5 class="card-title">
                          <b>{{ aitem.room_name }}</b>
                        </h5>
                        <p class="card-text mb-3 ms-1 detail-size-text">
                          <i class="fa-solid fa-location-dot"></i>
                          {{ aitem.room_desc }}
                        </p>
                        <!-- end tem img -->
                        <span
                          v-if="
                            aitem.status === 1 ||
                            (aitem.status === 0 && aitem.freetimes.length === 0)
                          "
                        >
                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            08:30 - 12:00
                          </b-button>

                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            13:00 - 16:30
                          </b-button>
                        </span>
                        <!--  -->
                        <span v-for="(prod, j) of aitem.freetimes" :key="j">
                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                            v-if="
                              aitem.freetimes.length === 1 &&
                              aitem.status === 0 &&
                              prod.time_begin === '13:00'
                            "
                          >
                            08:30-12:00
                          </b-button>

                          <b-button
                            v-if="
                              prod.time_begin !== '08:30' ||
                              prod.time_end !== '16:30'
                            "
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-pink"
                            v-b-modal="
                              'modal-racord-teacher' +
                              aitem.room_id +
                              prod.time_id
                            "
                            @click="getUsefor(aitem.room_id)"
                          >
                            {{ prod.time_begin }} - {{ prod.time_end }}
                          </b-button>
                          <!--  -->
                          <span
                            v-for="(timechkuser, iu) in historyall"
                            :key="iu"
                          >
                            <b-button
                              class="btn mb-1 mt-1 time-btn"
                              pill
                              variant="outline-secondary"
                              disabled
                              v-if="
                                timechkuser.room_id === aitem.room_id &&
                                timechkuser.time_begin === '13:00' &&
                                timechkuser.time_begin !== prod.time_begin &&
                                aitem.freetimes.length === 1
                              "
                            >
                              13:00-16:30
                            </b-button>
                          </span>
                          <!-- =========================================== MODAL =  modal-racord-teacher ======================================-->
                          <b-modal
                            class="border-bottom-0"
                            :hide-footer="true"
                            centered
                            size="lg"
                            :id="
                              'modal-racord-teacher' +
                              aitem.room_id +
                              prod.time_id
                            "
                            header-border-variant="white"
                            v-if="chkbookingroom"
                          >
                            <template #modal-title>
                              <div
                                class="card card-order-list card-margin shadow border-light"
                              >
                                <div class="card-body">
                                  <i class="fa-solid fa-bookmark"></i>
                                  ห้อง {{ aitem.room_name }} เวลาจอง
                                  {{ prod.time_begin }} -
                                  {{ prod.time_end }}
                                </div>
                              </div>
                            </template>
                            <!--  -->
                            <div
                              class="card card-order-list card-margin shadow border-light"
                            >
                              <div class="card-body">
                                <form
                                  action=""
                                  class="form-group"
                                  @submit.prevent="
                                    bookingAnother(
                                      aitem.room_id,
                                      prod.time_begin,
                                      prod.time_end,
                                      prod.time_id,
                                      'modal-racord-teacher' +
                                        aitem.room_id +
                                        prod.time_id
                                    )
                                  "
                                >
                                  <p style="color: blue">
                                    *หมายเหตุ : กรุณาเลือกวัตุประสงค์การใช้งาน
                                  </p>

                                  <b-form-select
                                    class="mb-3 input-style"
                                    v-model="selected"
                                    :options="options"
                                    value-field="usefor_id"
                                    text-field="usefor_name"
                                    disabled-field="notEnabled"
                                  >
                                    <template #first>
                                      <b-form-select-option
                                        :value="null"
                                        disabled
                                      >
                                        เลือกวัตถุประสงค์การใช้งาน
                                      </b-form-select-option>
                                    </template>
                                  </b-form-select>

                                  <!--  -->
                                  <span
                                    style="color: red; font-weight: bold"
                                    v-if="error != '' || error === null"
                                  >
                                    ERROR : {{ error }}
                                    <br />
                                    <br />
                                  </span>
                                  <input
                                    type="text"
                                    class="form-control input-style"
                                    placeholder="กรอกวัตถุประสงค์"
                                    v-model="input_another"
                                    v-if="
                                      selected === 7 ||
                                      selected === 13 ||
                                      selected === 16
                                    "
                                  />
                                  <!-- BTN submit -->
                                  <b-button
                                    class="btn btn-pink deep-purple btn-block badg-pill"
                                    :disabled="!isCompleteTeach"
                                    type="submit"
                                    data-dismiss="modal"
                                    @click="showModal = false"
                                  >
                                    ยืนยัน
                                  </b-button>
                                </form>
                              </div>
                            </div>
                          </b-modal>

                          <!-- หากมีการจองแล้ว จะแสดง tag นี้จ้า -->
                          <b-modal
                            :hide-footer="true"
                            :hide-header="true"
                            centered
                            size="lg"
                            :id="
                              'modal-racord-teacher' +
                              aitem.room_id +
                              prod.time_id
                            "
                            header-border-variant="white"
                            class="border-bottom-0"
                            v-if="!chkbookingroom"
                          >
                            <div
                              class="card-body justify-content-center card-block p-3 text-center text-danger"
                            >
                              <h5>
                                <i class="fa-solid fa-circle-exclamation"></i>
                                {{ msgbookingroom }}
                              </h5>
                            </div>
                          </b-modal>
                          <!-- =========================================== END MODAL =  modal-racord-teacher ======================================-->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
              <!-- END TEACHER -->
              <!-- STD -->
              <span v-if="isShowstaff">
                <div class="card-input">
                  <div
                    class="top-50 start-50 translate-middle"
                    v-if="aitem.room_id === 10"
                  >
                    <div
                      class="animate__animated animate bounce card card-detail-tebs"
                      style="width: 18rem"
                    >
                      <!-- img -->
                      <div class="container mt-3 container-img">
                        <img
                          v-if="aitem.room_id === 10"
                          src="../../assets/meetingrooms/rac.jpeg"
                          alt=""
                          class="card-img-top"
                        />
                      </div>
                      <!-- end img -->

                      <!-- text img  -->
                      <div class="card-body">
                        <h5 class="card-title">
                          <b>{{ aitem.room_name }}</b>
                        </h5>
                        <p class="card-text mb-3 ms-1 detail-size-text">
                          <i class="fa-solid fa-location-dot"></i>
                          {{ aitem.room_desc }}
                        </p>

                        <!-- end text img  -->
                        <!-- btn time -->
                        <span
                          v-if="
                            aitem.status === 1 ||
                            (aitem.status === 0 && aitem.freetimes.length === 0)
                          "
                        >
                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            08:30 - 12:00
                          </b-button>
                          <b-button
                            class="btn mb-1 mt-1 time-btn"
                            pill
                            variant="outline-secondary"
                            disabled
                          >
                            13:00 - 16:30
                          </b-button>
                        </span>
                        <!--  -->
                        <span v-for="(prod, j) of aitem.freetimes" :key="j">
                          <span v-if="!user">
                            <b-button
                              class="btn mt-1 mb-1 time-btn"
                              v-if="
                                aitem.freetimes.length === 1 &&
                                aitem.status === 0 &&
                                prod.time_begin === '13:00'
                              "
                              variant="outline-secondary"
                              pill
                              disabled
                            >
                              08:30 - 12:00
                            </b-button>

                            <b-button
                              v-if="
                                aitem.freetimes.length === 1 &&
                                aitem.status === 0 &&
                                prod.time_begin === '16:30'
                              "
                              class="btn mb-1 mt-1 time-btn"
                              pill
                              variant="outline-secondary"
                              disabled
                            >
                              13:00 - 16:30
                            </b-button>

                            <b-button
                              class="btn mt-1 mb-1 time-btn"
                              variant="outline-pink"
                              v-b-modal="
                                'modal-racord-std' +
                                aitem.room_id +
                                prod.time_id
                              "
                              @click="getUsefor(aitem.room_id)"
                              v-if="
                                prod.time_begin !== '08:30' ||
                                prod.time_end !== '16:30'
                              "
                            >
                              {{ prod.time_begin }} - {{ prod.time_end }}
                            </b-button>

                            <span
                              v-for="(timechkuse, iue) in historyall"
                              :key="iue"
                            >
                              <b-button
                                class="btn mt-1 mb-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                                v-if="
                                  timechkuse.room_id === aitem.room_id &&
                                  timechkuse.time_begin === '13:00' &&
                                  timechkuse.time_begin !== prod.time_begin &&
                                  aitem.freetimes.length === 1
                                "
                              >
                                13:00 - 16:30
                              </b-button>
                            </span>
                          </span>
                          <!-- end !user  -->
                          <!-- if = user -->
                          <span v-if="user">
                            <b-button
                              class="btn mt-1 mb-1 time-btn"
                              variant="outline-secondary"
                              pill
                              disabled
                              v-if="
                                aitem.freetimes.length === 1 &&
                                aitem.status === 0 &&
                                prod.time_begin === '13:00'
                              "
                            >
                              08:30 - 12:00
                            </b-button>

                            <b-button
                              class="btn mt-1 mb-1 time-btn"
                              pill
                              variant="outline-pink"
                              href="/login"
                              v-if="
                                prod.time_begin !== '08:30' ||
                                (prod.time_end !== '16:30' &&
                                  aitem.freetims.length !== 0)
                              "
                            >
                              {{ prod.time_begin }} - {{ prod.time_end }}
                            </b-button>
                            <b-button
                                v-if="
                                  aitem.freetimes.length === 1 &&
                                  prod.time_begin === '08:30'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="btn mb-1 mt-1 time-btn"
                              >
                                13:00 -16:30
                              </b-button>
                            <span
                              v-for="(timechkuse, iu) in historyall"
                              :key="iu"
                            >
                              <b-button
                                class="btn mt-1 mb-1 time-btn"
                                pill
                                variant="outline-secondary"
                                disabled
                                v-if="
                                  timechkuse.room_id === aitem.room_id &&
                                  timechkuse.time_begin === '13:00' &&
                                  timechkuse.time_begin !== prod.time_begin &&
                                  aitem.freetimes.length === 1
                                "
                              >
                                13:00 - 16:30
                              </b-button>
                            </span>
                          </span>
                          <!-- END if = user -->
                          <!-- =============================================== MODAL =  modal-racord-std  =============================================== -->

                          <b-modal
                            class="border-bottom-0"
                            v-if="chkbookingroom"
                            :hide-footer="true"
                            centered
                            size="lg"
                            :id="
                              'modal-racord-std' + aitem.room_id + prod.time_id
                            "
                            header-border-variant="white"
                          >
                            <template #modal-title>
                              <div
                                class="card card-order-list card-margin shadow-sm border-light card-time-title"
                              >
                                <div class="card-body">
                                  <i class="fa-solid fa-bookmark"></i>
                                  ห้อง {{ aitem.room_name }} เวลาจอง
                                  {{ prod.time_begin }} -
                                  {{ prod.time_end }}
                                </div>
                              </div>
                            </template>

                            <div
                              class="card card-order-list card-margin shadow-sm border-light card-time-body"
                            >
                              <div class="card-body">
                                <form
                                      class="form-group"
                                      @submit.prevent="
                                        booking(
                                          aitem.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-racord-std' +
                                            aitem.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        (auth.isLibraryStaff === 1 &&
                                          aitem.floor !== 6) ||
                                        auth.LibraryStaff !== 1
                                      "
                                    >
                                  <b-form-select
                                    class="mb-3 input-style"
                                    v-model="selected"
                                    :options="options"
                                    value-field="usefor_id"
                                    text-field="usefor_name"
                                    disabled-field="notEnabled"
                                  >
                                    <template #first>
                                      <b-form-select-option
                                        :value="null"
                                        disabled
                                      >
                                        เลือกวัตถุประสงค์การใช้งาน
                                      </b-form-select-option>
                                    </template>
                                  </b-form-select>
                                  <!--  -->
                                  <input
                                    type="text"
                                    class="form-control input-style"
                                    placeholder="กรอกวัตถุประสงค์"
                                    v-model="input_another"
                                    v-if="
                                      selected === 7 ||
                                      selected === 13 ||
                                      selected === 16
                                    "
                                  />
                                  <p style="color: red">
                                    **หมายเหตุ : กรอกรหัสนักศึกษา
                                    {{ aitem.min_person }} คนขึ้นไป
                                  </p>

                                  <span
                                    style="color: red"
                                    v-if="error != '' || error === null"
                                  >
                                    ** {{ error }}
                                  </span>
                                  <!--  -->
                                  <b-row>
                                    <b-col
                                      cols="6"
                                      v-for="(stdr, index) in input_stdcode"
                                      :key="index"
                                    >
                                      <input
                                        class="form-control input-style"
                                        placeholder="กรอกรหัสนักศึกษา"
                                        maxlength="11"
                                        v-model="values[index]"
                                      />
                                    </b-col>
                                  </b-row>
                                  <b-button
                                    class="btn btn-pink deep-purple btn-block badge-pill"
                                    data-dismiss="model"
                                    @click="showMoal = false"
                                    :disabled="!isComplete"
                                    type="submit"
                                  >
                                    ยืนยัน std
                                  </b-button>
                                </form>
                                <!--  -->

                                <form
                                  action=""
                                  class="form-group"
                                  @submit.prevent="
                                    bookingAnother(
                                      aitem.room_id,
                                      prod.time_begin,
                                      prod.time_end,
                                      prod.time_id,
                                      'modal-racord-std' +
                                        aitem.room_id +
                                        prod.time_id
                                    )
                                  "
                                  v-if="
                                    auth.isLibraryStaff === 1 &&
                                    aitem.floor === 6
                                  "
                                >
                                  <b-button variant="outline-primary">
                                    สำหรับอาจารย์
                                  </b-button>

                                  <span
                                    style="color: red; font-weight: bold"
                                    v-if="error != '' || error === null"
                                  >
                                    ERROR :{{ error }}
                                    <br />
                                    <br />
                                  </span>

                                  <b-row>
                                    <b-col cols="6">
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="เบอร์โทรศัพท์"
                                        maxlength="10"
                                        v-model="input_room_Teacher_phone"
                                      />
                                    </b-col>
                                    <b-col cols="6">
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="ชื่อ - นามสกุล"
                                        v-model="input_room_Teacher_name"
                                        autocomplete
                                      />
                                    </b-col>
                                    <!-- options fac -->
                                    <b-col cols="6">
                                      <b-form-select
                                        class="mb-3 input-style"
                                        v-model="selectedfac"
                                        :options="optionsfac"
                                        value-field="fac_code"
                                        text-field="fac_name"
                                        disabled-field="notEnabled"
                                        @change="get_branch()"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                          >
                                            เลือกคณะ
                                          </b-form-select-option>
                                        </template>
                                      </b-form-select>
                                    </b-col>
                                    <!-- end options fac -->
                                    <!-- option branch -->
                                    <b-col cols="6">
                                      <b-form-select
                                        class="mb-3 input-style"
                                        v-model="selectedbranch"
                                        :options="optionsbranch"
                                        value-field="branch_code"
                                        text-field="branch_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                          >
                                            เลือกสาขา
                                          </b-form-select-option>
                                        </template>
                                      </b-form-select>
                                    </b-col>
                                    <!-- end option branch -->
                                    <b-col cols="6">
                                      <input
                                        type="email"
                                        class="form-control input-style"
                                        placeholder="อีเมล"
                                        maxlength=""
                                        v-model="input_room_Teacher_email"
                                      />
                                    </b-col>

                                    <b-col cols="6">
                                      <b-form-select
                                        class="mb-3 input-style"
                                        v-model="selected"
                                        :options="options"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                          >
                                            เลือกวัตถุประสงค์การใช้งาน
                                          </b-form-select-option>
                                        </template>
                                      </b-form-select>
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />
                                    </b-col>
                                  </b-row>
                                  <!-- submint btn -->
                                  <b-button
                                    class="btn btn-pink deep-purple btn-block badge-pill"
                                    v-if="
                                      auth.isLibraryStaff === 1 &&
                                      aitem.floor === 6
                                    "
                                    type="submit"
                                    data-dismiss="modal"
                                    @click="showModal = false"
                                  >
                                    ยืนยัน
                                  </b-button>
                                </form>
                              </div>
                            </div>
                          </b-modal>
                          <!-- =============================================== END MODAL =  modal-racord-std  =============================================== -->
                          <!-- เมื่อมีการจองแล้วจะโชว์,Modal นี้เพื่อแจ้งว่ามีการจองแล้วจ้าา -->

                          <b-modal
                            class="border-bottom-0"
                            :hide-footer="true"
                            :hide-header="true"
                            centered
                            size="lg"
                            :id="
                              'modal-racord-std' + aitem.room_id + prod.time_id
                            "
                            header-border-variant="white"
                            v-if="!chkbookingroom"
                          >
                            <div
                              class="card-body justify-content-center card-block p-3 text-center text-danger"
                            >
                              <h5>
                                <i class="fa-solid fa-circle-exclamation"></i>
                                {{ msgbookingroom }}
                              </h5>
                            </div>
                          </b-modal>
                          <!--  -->
                        </span>

                        <!-- end btn time -->
                      </div>
                      <!-- end card-body -->
                    </div>
                  </div>
                </div>
              </span>
              <!-- END STD -->
            </span>
          </div>

          <!-- *************** END ห้อง บันทึกเสียง *********************** -->
        </div>
        <!-- *********************** END ห้องบันทึกเสียง****************** -->

        <!-- ======================= END ========================= -->
      </b-container>
    </div>
  </div>
</template>

<script>
import Sidebar_user from "../layouts/sidebar_user.vue";
import $ from "jquery";
import VueHorizontalCalendar from "vue-horizontal-calendar";

import moment from "moment";
import axios from "axios";

// import axios from "axios";
export default {
  name: "Bookroom",
  components: { Sidebar_user, VueHorizontalCalendar },
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      orders: [],
      radio_btn: "",
      tabs: [],
      dateTime: new Date(),
      choosedDay2: {
        dateFormat: "",
        year: "",
        month: "",
        date: "",
        day: "",
        timestamp: "",
      },
      buildings: [
        {
          name: "อาคาร 13",
          detail: 0,
        },
        { name: "อาคาร 14", detail: 1 },
      ],
      activeIndex: 0,
      // getRoom()
      list: [],
      //get Auth
      user: false,
      code: "",
      auth: "",
      //อาคาร13
      itembd: [],
      //history
      history: [],
      chkbookingroom: [],
      msgbookingroom: "",
      status_show: false,
      //historyAll
      historyall: [],
      //getusefor
      showModal: false,
      selected: null,
      selected2: null,
      selected3: null,
      options: [],
      optionsfac: [],
      selectedfac: null,
      optionsbranch: [],
      selectedbranch: null,
      dbroom: [],
      dbroomMax: "",
      dbroomMin: "",
      stdr: [],
      values: {},
      res: [],
      error: "",
      input_another: "",
      isShowstaff: false,
      input_room_Teacher: {
        phone: "",
        name: "name",
        fac: "",
        branch: "",
        email: "",
      },
      input_room_Teacher_name: "",
      input_room_Teacher_phone: "",
      input_room_Teacher_fac: "",
      input_room_Teacher_branch: "",
      input_room_Teacher_email: "",
      fac_code: "",
      branch_code: "",
      input_stdcode: [{}],
      // booking Another
    };
  },

  mounted() {
    //Run Function
    this.getHistoryAll();
    this.getIP();
    // this.get_room();

    // this.getHistory();
    this.get_fac();
    //Get Auth
    if (localStorage.getItem("auth") != null) {
      this.getorders();
      this.user = false;

      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;

      // console.log(this.input_room_Teacher.name);
      if (this.auth.user_type === "Teacher" || this.auth.isLibraryStaff === 0) {
        this.isShowstaff;
        this.input_room_Teacher_name = this.auth.std_name;
        this.fac_code = this.auth.fac_code;
        this.branch_code = this.auth.branch_code;
        (this.input_room_Teacher_phone = this.code),
          (this.input_room_Teacher_email = "");
        this.input_room_Teacher_fac = this.auth.fac_name;
        this.input_room_Teacher_branch = this.auth.branch_name;
      } else if (this.auth.user_type === "Student") {
        this.isShowstaff = true;
      }

      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
        this.input_room_Teacher_name = "";
        this.fac_code = "";
        this.branch_code = "";
        (this.input_room_Teacher_phone = ""),
          (this.input_room_Teacher_email = "");
        this.input_room_Teacher_fac = "";
        this.input_room_Teacher_branch = "";
      } else {
        this.staff = false;
      }

      if (localStorage.getItem("orders") != null) {
        this.loadOrder();
      }
    } else {
      this.user = true;
      this.isShowstaff = true;
    }
    //
    if (localStorage.getItem("booking") != null) {
      this.loadBooking();
    }
    setInterval(() => {
      this.get_room();
      this.getHistory();
    }, 15000);

    window.setTimeout(function () {
      $(".alert")
        .fadeTo(500, 0)
        .slideUp(500, function () {
          $(this).remove();
        });
    }, 3000);
    //
    $("#deployform").click(function () {
      $(this).addClass("open");
    });
    $(".cancel").click(function () {
      $(this).parent().removeClass("open");
      // eslint-disable-next-line no-undef
      e.stopPropagation();
    });

    let sidebar = document.querySelector(".sidebar");
    let closeBtn = document.querySelector("#btn");
    // let searchBtn = document.querySelector(".bx-search");

    closeBtn.addEventListener("click", () => {
      sidebar.classList.toggle("open");
      menuBtnChange(); //calling the function(optional)
    });

    // searchBtn.addEventListener("click", () => {
    //   // Sidebar open when you click on the search iocn
    //   sidebar.classList.toggle("open");
    //   menuBtnChange(); //calling the function(optional)
    // });

    // following are the code to change sidebar button(optional)
    function menuBtnChange() {
      if (sidebar.classList.contains("open")) {
        closeBtn.classList.replace("bx-menu", "bx-menu-alt-right"); //replacing the iocns class
      } else {
        closeBtn.classList.replace("bx-menu-alt-right", "bx-menu"); //replacing the iocns class
      }
    }
  },
  methods: {
    onChange() {
      // console.log(this.radio_btn);
    },
    //loader
    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    loadBooking() {
      this.items = JSON.parse(localStorage.getItem("booking"));
    },

    selectBuilding(index) {
      this.activeIndex = index;
    },
    // get IP
    getIP() {
      this.getIPAddress().then((res) => {
        this.ipAddress = res.data.ip;
        localStorage.setItem("IP", this.ipAddress);
      });
    },
    getIPAddress() {
      return axios.get("https://api.ipify.org/?format=json");
    },
    // GET : ROOM
    get_room() {
      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };

      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      // this.$isLoading(true);

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);

          if (res.data.msg.status === 200) {
            this.itembd = res.data.room_status;
            // console.log("Get Room", res);
            // this.$isLoading(false);
          } else {
            alert(res.data.msg.message);
          }
        });
    },
    //GET : History
    getHistory() {
      // console.log(this.choosedDay2);
      // this.dateChange2(this.choosedDay2);
      let data = {
        select_date: this.choosedDay2.dateFormat,
        std_code: this.code,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_per_std", data, {
          headers,
        })
        .then((res) => {
          // console.log("res history==", res.data.is_can_i_booking
          // );

          // this.statsut_show =  false;
          if (this.auth.length !== 0) {
            // console.log("code",this.auth);
            if (res.data.msg.status === 200) {
              this.history = res.data.histories;
              // this.chkbookingroom = true;
              this.chkbookingroom = res.data.is_can_i_booking;
              this.msgbookingroom = res.data.is_can_i_booking_msg;
              if (this.history.length === 0) {
                this.status_show = false;
              } else {
                this.status_show = true;
              }
            } else {
              alert(res.data.msg.message);
            }
          } else {
            // console.log("No code");
            this.status_show = false;
          }
        });
      // getroom
    },
    //GET : HistoryAll
    getHistoryAll() {
      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };
      // console.log("get story data ==", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_all", data, {
          headers,
        })
        .then((res) => {
          // console.log("res historyAll==", res);
          if (this.auth.length !== 0) {
            if (res.data.msg.status === 200) {
              this.historyall = res.data.histories;
              // console.log("this.historyall historyAll==", this.historyall);
              this.$isLoading(false);
              if (this.history.length === 0) {
                this.status_show = false;
              } else {
                this.status_show = true;
              }
            } else {
              this.$isLoading(false);

              alert(res.data.msg.message);
            }
          } else {
            this.status_show = false;
            this.$isLoading(false);
          }
        });
    },
    //GET : UseFor
    getUsefor(roomId) {
      this.showModal = true;
      this.selected = null;
      this.error = "";
      this.input_another = "";
      this.res = [];
      this.input_room_Teacher.phone = "";
      this.input_room_Teacher.name = "";
      this.input_room_Teacher.fac = null;
      this.input_room_Teacher.branch = null;
      this.input_room_Teacher.email = "";

      let data = {
        room_id: roomId,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step2_getusefor", data, {
          headers,
        })
        .then((res) => {
          this.dbroom = res.data.room;
          this.options = res.data.data;
          this.dbroomMax = res.data.room[0].max_person;
          this.dbroomMin = res.data.room[0].min_person;
          this.input_stdcode = [{}];
          this.values = {};
          for (var i = 1; i < this.dbroomMax; i++) {
            this.input_stdcode.push({ std: "" });
          }
        });
    },
    //GET : FAC
    get_fac() {
      const token = this.tokenjong;
      let data = {
        token: token,
        search_with_fac_code: "",
      };
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/get_faculty", data, {
          headers,
        })
        .then((res) => {
          this.optionsfac = res.data.faculties;
        });
    },
    //GET : Branch
    get_branch() {
      const token = this.tokenjong;
      let data = {
        token: token,
        fac_code: this.selectedfac,
      };
      // console.log(data);
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/room/get_branch_withfac",
          data,
          {
            headers,
          }
        )
        .then((res) => {
          this.optionsbranch = res.data.branches;
        });
    },
    //Booking student
    booking(room_id, time_begin, time_end, time_id, id) {
      // console.log(" another ==", room_id);
      this.list = [];

      let ip = localStorage.getItem("IP");

      for (var key of Object.keys(this.values)) {
        this.res.push(this.values[key]);
      }

      let data = {
        select_date: this.choosedDay2.dateFormat,
        room_id: room_id,
        time_id: time_id,
        time_begin: time_begin,
        time_end: time_end,
        usefor_id: this.selected,
        usefor_title: this.input_another,
        std_code: this.res,
        public_ip: ip,
        whois_std_code: this.code,
        isteacher: false,
      };
      // console.log("Booking",data,id);
      // console.log("Booking ===", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step3_confirm", data, {
          headers,
        })
        .then((res) => {
          // console.log(" booking ==", res.data);
          if (res.data.msg.status === 200) {
            this.$isLoading(false);
            this.itembd = res.data.room_status;
            if (this.auth.length !== 0) {
              this.status_show = true;
            } else {
              this.status_show = false;
            }

            this.getHistory();
            // this.histories = res.data.histories;
            this.$bvModal.hide(id);
            this.itembd.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            //  router.push('/meetingRoom');
            // console.log("true Booking ");
          } else {
            this.$isLoading(false);
            this.error = res.data.msg.message;
            this.res = [];
          }

          // console.log(res.data);
        });
    },
    //Booking Another
    bookingAnother(room_id, time_begin, time_end, time_id, id) {
    // console.log(room_id, time_begin, time_end, time_id, id);
    
      this.list = [];
      let data;
      let ip = localStorage.getItem("IP");

      for (var key of Object.keys(this.values)) {
        this.res.push(this.values[key]);
      }
      if (this.auth.isLibraryStaff === 1) {
        data = {
          select_date: this.choosedDay2.dateFormat,
          room_id: room_id,
          time_id: time_id,
          time_begin: time_begin,
          time_end: time_end,
          usefor_id: this.selected,
          usefor_title: this.input_another,
          std_code: this.res,
          public_ip: ip,
          whois_std_code: this.code,
          teach_name: this.input_room_Teacher_name,
          teach_tel: this.input_room_Teacher_phone,
          teach_email: this.input_room_Teacher_email,
          fac_code: this.selectedfac,
          branch_code: this.selectedbranch,
          isteacher: true,
        };
      } else {
        data = {
          select_date: this.choosedDay2.dateFormat,
          room_id: room_id,
          time_id: time_id,
          time_begin: time_begin,
          time_end: time_end,
          usefor_id: this.selected,
          usefor_title: this.input_another,
          std_code: this.res,
          public_ip: ip,
          whois_std_code: this.code,
          teach_name: this.input_room_Teacher_name,
          teach_tel: this.input_room_Teacher_phone,
          teach_email: this.input_room_Teacher_email,
          fac_code: this.fac_code,
          branch_code: this.branch_code,
          isteacher: true,
        };
      }
      // console.log(id);

      // console.log("Booking", data);
      // console.log("Booking Anthor===", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step3_confirm", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status === 200) {
            this.$isLoading(false);
            this.itembd = res.data.room_status;
            if (this.auth.length !== 0) {
              this.status_show = true;
            } else {
              this.status_show = false;
            }
            this.status_show = true;
            this.getHistory();
            this.histories = res.data.histories;
            this.$bvModal.hide(id);
            this.itembd.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            // eslint-disable-next-line no-undef
            router.push("/meetingRoom");
            // console.log("true Booking ");
          } else {
            this.$isLoading(false);
            this.error = res.data.msg.message;
            this.res = [];
          }
        });
    },
    //date chang2
    dateChange2(day) {
      // console.log("data day To",day);
      // this.chkDate = day;
      // console.log("checkdat",this.checkDate);
      this.list = [];
      if (localStorage.getItem("auth") != null) {
        this.user = false;
        this.auth = JSON.parse(localStorage.getItem("auth"));
        this.code = this.auth.std_code;
        // console.log(this.auth);
        if (this.auth.user_type === "Teacher") {
          this.isShowstaff;
          // console.log("Teacher");
        } else if (
          this.auth.user_type === "Student" ||
          this.auth.isLibraryStaff != 0
        ) {
          this.isShowstaff = true;
          // console.log("Student");
        }

        if (this.auth.isLibraryStaff === 1) {
          this.staff = true;
        } else {
          this.staff = false;
        }

        if (localStorage.getItem("orders") != null) {
          this.loadOrder();
        }
      } else {
        this.user = true;
        this.isShowstaff = true;
        // console.log("anothor");
      }

      this.choosedDay2 = day;
      this.date = this.choosedDay2.dateFormat;
      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };
      // console.log("datetime ====", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      // this.getHistory();
      this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.itembd = res.data.room_status;
            this.$isLoading(false);

            // console.log("Status == ",this.itembd);
            this.histories = res.data.histories;
            this.itembd.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }

              // console.log("chk", item, index);
            });

            // console.log("Room ", this.list);
          }
        });
    },
    // Get Order
    getorders() {
      let c = JSON.parse(localStorage.getItem("auth"));
      let data = {
        token: this.token,
        std_code: c.std_code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            if (res.data.Orders !== null) {
              this.orders = res.data.Orders;
              for (var i in this.orders) {
                if (this.orders[i].order_status === 5) {
                  this.orders.splice(this.orders.indexOf(this.orders[i]), 1);
                }
              }

              localStorage.setItem("orders", JSON.stringify(this.orders));
              this.show = true;
            }
          }
        });
    },
  },
  computed: {
    showExtraDiv() {
      // console.log(this.activeIndex);

      return this.activeIndex === 0 || this.activeIndex === 1;
    },

    isComplete() {
      var t;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        t =
          (this.values[0] &&
            this.values[1] &&
            this.selected &&
            this.input_another) ||
          (this.values[0] &&
            this.values[2] &&
            this.selected &&
            this.input_another);
      } else {
        t =
          (this.values[0] && this.values[1] && this.selected) ||
          (this.values[0] && this.values[2] && this.selected);
      }
      return t;
    },
    isCompleteTeach() {
      var te;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        te = this.selected && this.input_another;
      } else {
        te = this.selected;
      }
      return te;
    },
    isCompleteAnothor() {
      var s;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        s =
          this.input_room_Teacher_name &&
          this.input_room_Teacher_phone &&
          this.selectedfac &&
          this.selectedbranch &&
          this.input_room_Teacher_email &&
          this.selected &&
          this.input_another;
      } else {
        s =
          this.input_room_Teacher_name &&
          this.input_room_Teacher_phone &&
          this.selectedfac &&
          this.selectedbranch &&
          this.input_room_Teacher_email &&
          this.selected;
      }

      return s;
    },
    isUser() {
      return this.user === "true"; // แปลง string → boolean
    },
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("LL");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-detail-tebs {
  border-radius: 40px;
  overflow: hidden;
  border: 0;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06), 0 2px 4px rgba(0, 0, 0, 0.07);
  transition: all 0.15s ease;
}
.card-detail-tebs:hover {
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.1), 0 10px 8px rgba(0, 0, 0, 0.015);
}
/*.card-detail-tebs .container {
  width: 88%;
 background: #F0EEF8;
  border-radius: 30px;
  height: 140px;
display: flex;
align-items: center;
justify-content: center;
}*/
.container-img :hover > img {
  transform: scale(1.2);
}

.container-img img {
  /*padding: 10px;  
  border-radius: 30px;
  height: 140px;
  width: 88%;
margin-top: -40px;
 margin-bottom: -40px;*/

  width: 100%;
  background: #f0eef8;
  border-radius: 30px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s ease;
  cursor: pointer;
}

.time-btn {
  /*background: #EEECF7;
  background: white;
  color: #5535F0;
  font-size: 1.2rem;*/
  border: 1;
  width: 98%;
  font-weight: bold;

  border-radius: 20px;
  height: 40px;
  transition: all 0.2s ease;
}

.time-btn:hover {
  /*background: #441CFF;*/
}

.time-btn:focus {
  /* background: #441CFF;
        outline: 0;  */
}
.detail-size-text {
  font-size: 0.8rem;
}
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250pa;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}
.space {
  height: 30px;
}

/* card calendar*/

/* card date */
.calendar-list .card {
  border-radius: 20px;
}

.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.shadow-date {
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}

.room-name {
  margin-left: 0px;
}
.card-header:first-child {
  /* border-radius: 0px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.card-columns .card {
  border-radius: 20px;
}
.calendar-list .card {
  border-radius: 20px;
}
.card-content-more {
  position: relative;
  /*color: orangered;*/
  color: #fc4170;
  font-weight: bold;
}

/*END*/

/* card */
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 3;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 3;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }

  .on-line {
    width: 6%;
    height: auto;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 3;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }
  .on-line {
    /* width: 8%; */
    height: auto;
  }
  .card-columns-left-item {
    column-count: 2;
  }
}

@media (max-width: 667px) {
  .on-line {
    width: 11%;
    height: auto;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}
/*End*/

/* ORDER LIST book  room*/
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}

.card-title {
  text-align: left;
  text-align: justify;
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  margin-bottom: -5px;
}
.text-muted i {
  margin: 0 5px;
}

.calendar-list .card {
  border-radius: 20px;
}

.horizontal-calendar {
  border-top: 0px !important;
  border: 0px;
}
.b-between {
  margin-right: 5px !important;
  margin-bottom: 5px;
}

.card .card_image {
  width: inherit;
  height: inherit;
  border-radius: 20px;
}

.card .card_image img {
  width: inherit;
  height: inherit;
  border-radius: 20px;
  object-fit: cover;
}
.card-status-booking {
  top: 1rem;
  margin-left: 9.5rem;
}
/* tebs content */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  top: 0rem;
  left: 0rem;
  font-size: 14px;
}

.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 20.5rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
  left: 0rem;
  top: 0rem;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  /*color: rgb(209, 95, 2);*/
  color: #ee2c5d;
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 7rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /*color: #ff5f2d;*/
  color: #fc4170;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: #ee2c5d;
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 7rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6.4rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(13rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.custom-button {
  margin-right: 12px; /* เว้นระยะห่างขวา */
  margin-bottom: 12px; /* เผื่อกรณี responsive แถวใหม่ */
}
/* end*/
/*btn color */
.btn-orange {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}

.btn-orange:hover {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}
.btn-orange:focus,
.btn-orange.focus {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
  box-shadow: 0 0 0 0.2rem rgba(180, 72, 112, 0.5);
}
.btn-orange.disabled,
.btn-orange:disabled {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}
.btn-orange:not(:disabled):not(.disabled):active,
.btn-orange:not(:disabled):not(.disabled).active,
.show > .btn-orange.dropdown-toggle {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--sub-color);
}
.btn-orange:not(:disabled):not(.disabled):active:focus,
.btn-orange:not(:disabled):not(.disabled).active:focus,
.show > .btn-orange.dropdown-toggle:focus {
  /*rgba(180, 72, 112, 0.5) rgba(255, 109, 65, 0.468);*/
  box-shadow: 0 0 0 0.2rem rgba(180, 72, 112, 0.5);
}

/* pink */
//pink
.btn-pink {
  color: #fff;
  border-color: #fc4170;
  background-color: #fc4170;
}

.btn-pink:hover {
  color: #fff;
  border-color: #ee97ad;
  background-color: #fa3f6e;
}
.btn-pink:focus,
.btn-pink.focus {
  color: #fff;
  border-color: #ee97ad;
  background-color: #fa3f6e;
  box-shadow: 0 0 0 0.2rem rgba(255, 118, 159, 0.468);
}
.btn-pink.disabled,
.btn-pink:disabled {
  color: #fff;
  border-color: #fc4170;
  background-color: #fc4170;
}
.btn-pink:not(:disabled):not(.disabled):active,
.btn-pink:not(:disabled):not(.disabled).active,
.show > .btn-pink.dropdown-toggle {
  color: #fff;
  border-color: #fc4170;
  background-color: #ee97ad;
}
.btn-pink:not(:disabled):not(.disabled):active:focus,
.btn-pink:not(:disabled):not(.disabled).active:focus,
.show > .btn-pink.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 118, 159, 0.468);
}
/*  */

.btn-outline-pink {
  color: #fc4170;
  border-color: #fc4170;
}

.btn-outline-pink:hover {
  color: #fff;
  background-color: #fc4170;
  border-color: #fc4170;
}

.btn-outline-pink:focus,
.btn-outline-pink.focus {
  box-shadow: 0 0 0 0.2rem #ee97ad;
}

.btn-outline-pink.disabled,
.btn-outline-pink:disabled {
  color: #fc4170;
  background-color: transparent;
}

.btn-outline-pink:not(:disabled):not(.disabled):active,
.btn-outline-pink:not(:disabled):not(.disabled).active,
.show > .btn-outline-pink.dropdown-toggle {
  color: #fff;
  background-color: #fc4170;
  border-color: #fc4170;
}

.btn-outline-pink:not(:disabled):not(.disabled):active:focus,
.btn-outline-pink:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-pink.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem #ee97ad;
}

/*.btn-outline-pink {
  #ed3d6f
  color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}
.btn-outline-pink:hover {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(255, 95, 45);
}
.btn-outline-pink:focus,
.btn-outline-pink.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
.btn-outline-pink.disabled,
.btn-outline-pink:disabled {
  color: #000000;
  background-color: transparent;
}
.btn-outline-pink:not(:disabled):not(.disabled):active,
.btn-outline-pink:not(:disabled):not(.disabled).active,
.show > .btn-outline-pink.dropdown-toggle {
  color: #fff;
  border-color: #000000;
  background-color: #000000;
}
.btn-outline-pink:not(:disabled):not(.disabled):active:focus,
.btn-outline-pink:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-pink.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
*/

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}
#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #ffffff;
  border-color: #cecece;
  color: #000000;
}

.card-service {
  background-color: var(--greyLight-3);

  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-3),
    -0.2rem -0.2rem 1.8rem var(--white);
  background: none;
  font-family: inherit;
}
/*end*/
</style>
